<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<v-btn
									color="red"
									class="px-0"
									height="auto"
									exact
									x-large
									text
									:to="{name: `${locationName}-hub`}"
								>
									รวมโครงการ{{ location }}
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span v-if="params.category === 'singlehome'">
									บ้านเดี่ยว
								</span>
								<span v-else-if="params.category === 'townhome'">
									ทาวน์โฮม
								</span>
								<span v-else-if="params.category === 'condo'">
									คอนโด
								</span>
								<span v-else-if="params.category === 'shophouse'">
									อาคารพาณิชย์
								</span>
							</div>
							<div class="search-filter">
								<h1>
									รวมโครงการ{{ location }}
								</h1>

								<div class="pl-3 pr-5">
									<h2 v-if="params.category === 'singlehome'">
										บ้านเดี่ยว
									</h2>
									<h2 v-else-if="params.category === 'townhome'">
										ทาวน์โฮม
									</h2>
									<h2 v-else-if="params.category === 'condo'">
										คอนโด
									</h2>
									<h2 v-else-if="params.category === 'shophouse'">
										อาคารพาณิชย์
									</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="d-flex">
							<div class="px-4">
								<img
									:src="`/images/2.0/icon/${params.category}_i.png`"
									width="64"
								>
							</div>
							<div class="py-4">
								<template v-if="content === 'singlehome'">
									<h1 class="red--text">
										บ้านเดี่ยวสมุทรปราการ
									</h1>
									<p class="mt-4">
										"บ้านเดี่ยวสมุทรปราการ" เป็นบริเวณที่น่าจับตามองเพิ่มขึ้นในตลาดอสังหาริมทรัพย์ เนื่องจากมีการเชื่อมต่อของรถไฟฟ้า BTS ที่ขยายถึงช่วงเคหะฯ แล้ว บริเวณนี้มีทั้งโรงงานอุตสาหกรรมและอาหารสำนักงานทั้งหลาย ทั้งเก่าและใหม่ ที่สร้างแรงขับเคลื่อนให้ บ้านเดี่ยวสมุทรปราการมีความต้องการในการอยู่อาศัยที่เติบโตอย่างต่อเนื่อง บ้านสมุทรปราการ โดยเฉพาะอย่างยิ่งบ้านเดี่ยวและบ้านแฝดในโซนบางพลีและบางปู ให้บริการความสะดวกสบายในราคาที่พอเหมาะ ประมาณ 2-4 ล้านบาท.
									</p>
								</template>

								<template v-else-if="content === 'townhome'">
									<h1 class="red--text">
										ทาวน์โฮม ทาวน์เฮ้าส์สมุทรปราการ
									</h1>
									<p class="mt-4">
										ในพื้นที่ทำเล สมุทรปราการ นั้นถือว่าเป็นอีกหนึ่งทำเลที่น่าสนใจของการหาบ้านทาวน์โฮม ทาวน์เฮ้าส์ เพราะบริเวณพื้นที่สมุทรปราการ กำลังเป็นย่านเศรษฐกิจแห่งใหม่ ที่ไม่ไกลจากกรุงเทพ เป็นที่ตั้งของสถานที่สำคัญต่าง ๆ เช่น โรงเรียน มหาวิทยาลัย โรงพยาบาล ห้างสรรพสินค้า แหล่งนิคมอุตสาหกรรมอีกมากมาย ทำให้ย่านนี้มีดีมานด์ด้านการอยู่อาศัยเติบโตอย่างต่อเนื่อง โดย ทาวน์โฮม ทาวน์เฮ้าส์ ส่วนใหญ่จะเขยิบมาอยู่ในโซนเทพารักษ์ แพรกษา บางนา มากเป็นพิเศษ แถมยังอยู่ในเรตราคาที่วัยทำงานส่วนใหญ่เอื้อมถึงเฉลี่ยที่ประมาณ 1-4 ล้านบาท
									</p>
								</template>

								<template v-else-if="content === 'condo'">
									<h1 class="red--text">
										คอนโดสมุทรปราการ
									</h1>
									<p class="mt-4">
										พื้นที่ทำเลจังหวัดสมุทรปราการ ในปัจจุบันต้องยอมรับว่าเป็นย่านเศรษฐกิจที่กำลังเฟื่องฟู มีสถานที่สำคัญห้างสรรพสินค้า สถานศึกษา โรงพยาบาล รวมถึงสถานีรถไฟฟ้าหลายสถานี จึงทำให้ที่อยู่อาศัยประเภท คอนโด อาคารชุด ในสมุทรปราการได้รับความนิยมมากขึ้น ตอบโจทย์ความต้องการในการอยู่อาศัยของผู้คน ซึ่งคอนโดสมุทรปราการ ก็มีอยู่ในหลายทำเลพื้นที่โดยเฉพาะทำเลที่มีสถานศึกษา เช่น บางเสาธง บางพลี บางนา ศรีนครินทร์ โดยราคาจะอยู่ในเรทที่เอื้อมถึงตั้งแต่ 1-5 ล้านบาท
									</p>
								</template>

								<template v-else-if="content === 'shophouse'">
									<h1 class="red--text">
										อาคารพาณิชย์สมุทรปราการ
									</h1>
									<p class="mt-4">
										หากพูดถึงทำเล คอนโด, อาคารชุด หรืออาคารพาณิชย์สมุทรปราการ ซึ่งเป็นทำเลแห่งอนาคต ย่านชานเมืองที่กำลังจะกลายเป็นพื้นที่เศรษฐกิจแห่งใหม่ใกล้กรุงเทพ ที่ตอนนี้มีรถไฟฟ้า BTS ส่วนต่อขยาย แบริ่ง เคหะ เข้ามาสร้างความสะดวกสบายให้การใช้ชีวิต ซึ่งทำให้มีอาคารพาณิชย์ คอนโด อาคารชุด หลายแห่งเกิดขึ้นมากมายทั้งเก่าและใหม่ ทำให้ย่านสมุทรปราการได้รับความนิยมในการเป็นที่อยู่อาศัยมากขึ้น โดยอาคารพาณิชย์ คอนโด อาคารชุด ย่านสมุทรปราการจะอยู่ในทำเล บางพลี บางนา ศรีนครินทร์ มากเป็นพิเศษ และยังอยู่ในเรทราคาที่เอื้อมถึงได้ ตั้งแต่ 1 - 3 ล้านบาท
									</p>
								</template>

								<template v-else-if="content === 'srinakarin'">
									<h1 class="red--text">
										โครงการย่านศรีนครินทร์ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ย่านศรีนครินทร์ บางนา อ่อนนุช เป็นย่านที่อยู่อาศัยที่ได้รับอิทธิพลความเจริญมาจากย่านธุรกิจอย่างสุขุมวิท-อโศกที่มีราคาบ้าน คอนโด ทาวน์โฮมสูงมาก แต่เมื่อขยับออกมาในแถบศรีนครินทร์ บางนา อ่อนนุช ยังเป็นราคากลางๆ ไปจนถึงราคาสูงที่ยังสามารถจับต้องได้ แถมเหมาะสำหรับลงทุนเพราะราคาที่ดินเติบโตขึ้นทุกปี อีกทั้งเป็นทำเลที่เหมาะกับการอยู่อาศัย เพราะมีทั้งห้าง รถไฟฟ้า BTS ทางด่วน พื้นที่สีเขียว และถนนเส้นหลักตัดผ่านหลายสาย เช่น สุขุมวิท บางนา-ตราด ศรีนครินทร์ ตอบโจทย์ทุกไลฟ์สไตล์การใช้ชีวิตของคนเมือง
									</p>
								</template>

								<template v-else-if="content === 'thepharak'">
									<h1 class="red--text">
										โครงการบ้านย่านเทพารักษ์  สมุทรปราการ  บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										อยากซื้อบ้านในแถบชานเมืองอย่างจังหวัดสมุทรปราการเลือกที่ไหนดี? แนะนำทำเลบ้าน ‘ย่านเทพารักษ์’ ทำเลที่มีการเติบโตสูงและพัฒนาได้อย่างรวดเร็ว จากการเป็นแหล่งโรงงานอุตสาหกรรมและบริษัทเอกชน อีกทั้งยังเป็นทำเลใกล้เมืองที่เชื่อมต่อถนน 3 สายหลัก ได้แก่ ถนนสุขุมวิท, ถนนเทพารักษ์ และถนนศรีนครินทร์ จึงทำให้ย่านนี้คือแหล่งที่อยู่อาศัยในอนาคตที่ได้รับอิทธิพลความเจริญมาจากช่วงสุขุมวิทตอนปลายอย่างโซนบางนา-แบริ่ง ในราคาบ้านที่ยังจับต้องได้สำหรับคนวัยทำงานที่ต้องการความสงบแต่ก็ไม่ได้เดินทางเข้าสู่โซนเมืองยากมากนัก
									</p>
								</template>

								<template v-else-if="content === 'bang-phli'">
									<h1 class="red--text">
										โครงการบ้านเดี่ยวบางพลี สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										"บ้านเดี่ยวบางพลี-บางบ่อ" นับเป็นหนึ่งในสถานที่พักอาศัยที่น่าสนใจอย่างยิ่งของจังหวัดสมุทรปราการ ความเป็นมาของ บ้านเดี่ยวบางพลี นั้นอยู่บนจุดเชื่อมต่อสุดท้ายระหว่างกรุงเทพฯ, สมุทรปราการและฉะเชิงเทรา ซึ่งเป็นตำแหน่งที่สำคัญของบ้านเดี่ยวบางพลี ด้วยความสวยงามของย่านบางพลีที่เต็มไปด้วยสถานที่ท่องเที่ยวอันหลากหลาย เช่น เมกา บางนา, ตลาดน้ำโบราณบางพลี, และสกายเลน เป็นสถานที่ที่คนกรุงเทพฯ นิยมเดินทางไปสัมผัสประสบการณ์ นอกจากนี้ บ้านเดี่ยวบางพลียังตั้งอยู่ใกล้สนามบินสุวรรณภูมิ ทำให้บ้านบางพลีเป็นทำเลที่เหมาะสมสำหรับคนทำงานในสนามบิน หรือคนทำงานในโรงงานอุตสาหกรรม และภาคเกษตรกรรมใกล้เคียง "บ้านเดี่ยวบางพลี" จึงทางเลือกที่น่าสนใจสำหรับผู้ที่กำลังมองหาสถานที่พักอาศัย
									</p>
								</template>

								<template v-else-if="content === 'bangna-trad'">
									<h1 class="red--text">
										โครงการบ้านย่านบางนา-ตราด สมุทรปราการ ซื้อ ขาย บ้าน โครงการต่างๆ
									</h1>
									<p class="mt-4">
										ย่านบางนา-ตราด เรียกได้ว่าเป็นย่านที่อยู่อาศัยไม่ว่าจะเป็นบ้านเดี่ยว ทาวน์โฮม บ้านมือสองบางนา-ตราดฝั่งตะวันออกของกรุงเทพมหานคร เพราะนอกจากด้านทำเลที่เดินทางสะดวกจากการที่เชื่อมต่อถนนเส้นหลักอย่างสุขุมวิท-ศรีนครินทร์ได้ง่ายแล้ว ยังใกล้ทางด่วน ใกล้แหล่งชอปปิง อาหารการกินพร้อม ทั้งอิเกีย, เมกาบางนา, คิง พาวเวอร์ ศรีวารี, เซ็นทรัล วิลเลจ ลักซูรี่ เอาท์เล็ต แถมในอนาคตบ้านมือสองบางนา-ตราดจะมี Mix-Use เปิดตัวเพิ่มอีกหลายแห่ง แสดงให้เห็นว่าในอนาคตย่านนี้จะกลายเป็นทั้ง Hub ที่อยู่อาศัยและเป็นเมืองใหม่สำหรับการใช้ชีวิตอย่างแน่นอน
									</p>
								</template>

								<template v-else-if="content === 'phraeksa'">
									<h1 class="red--text">
										โครงการบ้าน แพรกษา สมุทรปราการ หมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม
									</h1>
									<p class="mt-4">
										‘บ้านย่านแพรกษา’ ดูจะเจริญเติบโตและมีจำนวนที่เพิ่มมากขึ้นเรื่อยๆ จากการพัฒนาของทำเลทั้งด้านการคมนาคม สิ่งอำนวยความสะดวก ซึ่งรองรับความต้องการของผู้อยู่อาศัยในที่ทำงานอยู่ในย่านโรงงานอุตสาหกรรม และนอกทำเลที่เป็นคนทำงานในบริเวณกรุงเทพฯ ชั้นในที่ต้องการซื้อบ้านเดี่ยว บ้านมือสอง ทาวน์โฮมในระดับราคาที่เอื้อมถึง โดยส่วนใหญ่จะอยู่ในกลุ่ม Main Class ระดับราคาตั้งแต่ 2 – 10 ล้านบาทขึ้นไป
									</p>
								</template>

								<template v-else-if="content === 'bangpu'">
									<h1 class="red--text">
										โครงการบ้านย่าน บางปู สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										‘บางปู’ นับเป็นทำเลของโครงการบ้าน บ้านเดี่ยว บ้านมือสอง ในจังหวัดสมุทรปราการตอนปลาย โดยเป็นแหล่งที่อยู่อาศัยใหม่ที่รองรับการขยายตัวของเมืองออกมาเรื่อยๆ อีกทั้งในทำเลนี้เป็นย่านของแหล่งโรงงานอุตสาหกรรมอย่าง นิคมอุตสาหกรรมบางปู จึงทำให้ทำเลนี้เป็นพื้นที่ชุมชนหนาแน่น มีดีมานด์ในการซื้อหรือเช่าบ้านอยู่เสมอ แถมในอนาคตจะมีสถานีรถไฟฟ้าสายสีเขียวส่วนต่อขยายเข้ามาอีก แน่นอนว่า ต้องทำให้ทำเลนี้คึกคักได้อีกหลายเท่าตัว
									</p>
								</template>

								<template v-else-if="content === 'phra-pradaeng'">
									<h1 class="red--text">
										โครงการบ้านย่าน พระประแดง สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										บ้านในแถบย่านพระประแดง ถือเป็นอีกย่านหนึ่งที่น่าสนใจในฝั่งตะวันออกเฉียงใต้ของกรุงเทพมหานคร เพราะเป็นทำเลที่มีความผสมผสานทั้งชุมชนดั้งเดิมและความเป็นเมืองใหม่ เพราะย่านนี้มีการคมนาคมที่สะดวก มีทั้งทางด่วน และทางเชื่อมต่อกับถนนหลายสายที่ทำให้เดินทางเข้าเมืองได้ง่าย ใกล้แหล่งงานสำคัญทั้งทางฝั่งสำโรง และพระราม 3 อีกทั้งยังจะมีรถไฟฟ้าสายสีม่วงส่วนต่อขยาย ช่วงเตาปูน – ราษฎร์บูรณะพาดผ่านอีก ยิ่งทำให้ทำเลนี้ทวีคูณศักยภาพในการเจริญเติบโตและกลายเป็นแหล่งที่อยู่อาศัยราคาไม่แพงสำหรับคนที่ต้องการซื้อบ้านอย่างแน่นอน
									</p>
								</template>

								<template v-else-if="content === 'phra-samut-chedi'">
									<h1 class="red--text">
										โครงการบ้านย่านพระสมุทรเจดีย์ สมุทรปราการ ซื้อ-ขาย  บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										พระสมุทรเจดีย์เป็นอำเภอหนึ่งในจังหวัดสมุทรปราการที่ปัจจุบันมีศักยภาพด้านทำเลมากขึ้นจากการเข้าถึงของรถไฟฟ้าสายสีม่วงใต้ ช่วงเตาปูน-ครุใน ทำให้ในทำเลมีโครงการบ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ เกิดขึ้นทั้งใหม่และเก่าเป็นจำนวนมาก อีกทั้งเป็นทำเลที่เดินทางสะดวก ใกล้ทั้งโซนปากน้ำ ใกล้ทางด่วน อีกทั้งมีถนนเชื่อมต่อ เพื่อเข้า-ออกเมืองได้อย่างรวดเร็ว และในอนาคตจะมีการสร้างเส้นทางตัดใหม่ที่วิ่งจากพระสมุทรเจดีย์ไปจังหวัดสมุทรสาครเพิ่มขึ้นอีกด้วย
									</p>
								</template>

								<template v-else-if="content === 'bearing'">
									<h1 class="red--text">
										โครงการบ้านย่านแบริ่ง สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										‘แบริ่ง’ นับเป็นทำเลฮอตฮิตที่มีคนลงทุนซื้อ-ขายบ้านเดี่ยว บ้านมือสอง คอนโด เป็นอันดับต้นๆ ของแถบฝั่งตะวันออกของกรุงเทพมหานครและจังหวัดสมุทรปราการ เนื่องจากทำเลค่อนข้างมีครบทุกอย่างทั้งด้านการเดินทาง การกินอยู่ แถมราคาอสังหาฯ ในแถบนี้ยังไม่สูงเท่ากับย่านอ่อนนุช-อุดมสุข ซึ่งตอนนี้กลายเป็นย่านที่อยู่อาศัยหลักของคนเมืองไปแล้ว ส่วนแบริ่งเองก็ได้รับอิทธิพลความเจริญและการขยายตัวของเมืองจากทำเลเหล่านั้นมาด้วยเช่นเดียวกัน
									</p>
								</template>

								<template v-else-if="content === 'lasalle'">
									<h1 class="red--text">
										โครงการบ้านย่าน ลาซาล สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ลาซาลอีกหนึ่งทำเลเนื้อหอมในช่วงสุขุมวิทตอนปลาย เพราะนี่คือย่านที่อยู่อาศัยสำหรับคนทำงานในกรุงเทพฯ ชั้นในแล้วต้องการอยากจะมีบ้านสักหลัง หรือคอนโดสักห้องในราคาที่ยังสามารถเอื้อมถึงได้ แถมยังเป็นย่านที่ตอบโจทย์ทุกไลฟ์สไตล์ของชีวิตเพราะเดินทางง่าย ใกล้รถไฟฟ้า มีทางด่วน และเชื่อมต่อถึงถนนหลักได้หลายสาย แถมยังมีแผนพัฒนาการคมนาคมอื่นๆ เพิ่มเติมในพื้นที่ ยิ่งทำให้ลาซาลกลายเป็นทำเลเติบโตอย่างต่อเนื่องทั้งในปัจจุบันและอนาคต
									</p>
								</template>

								<template v-else-if="content === 'samrong'">
									<h1 class="red--text">
										โครงการบ้านย่าน สำโรง สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ย่านสำโรง สำโรงเหนือ ซึ่งเป็นหนึ่งในย่านสำคัญของสมุทรปราการ ได้รับอิทธิพลการขยายเมืองจากกรุงเทพมหานคร โดยแผ่ขยายถึงย่านสำโรงทำให้ราคาซื้อ-ขายบ้านสำโรงทั้งบ้านเดี่ยว บ้านมือสอง โครงการหมู่บ้านมีราคาระดับกลางจับต้องได้มากกว่า ทั้งยังมีบ้านหลากหลายรูปแบบให้เลือกทั้งบ้านเดี่ยว เช่นโครงการล้วนพฤกษาเลควิลล์ หรือหมู่บ้านแฟนตาเซีย วิลล่า ซึ่งเป็นบ้านที่มีราคาสูงกว่า 10 ล้านบาทขึ้นไป หรือระดับกลางอย่าง พฤกษา วิลเลจ 23 ซีนเนอรี่ในราคาประมาณ 5 ล้านบาท
									</p>
								</template>

								<template v-else-if="content === 'bang-bo'">
									<h1 class="red--text">
										โครงการบ้านย่าน บางบ่อ สมุทรปราการ ซื้อ ขาย โครงการหมู่บ้าน บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ย่านบางบ่อ-บางพลีเป็นย่านที่ขยับออกมาจากบางนาเพียงไม่ไกล นับเป็นแหล่งที่อยู่อาศัยที่ได้รับอิทธิพลความเจริญที่ส่งต่อมาจากโซนบางนา และยังเป็นเขตที่พักอาศัยใกล้นิคมอุตสาหกรรมใหญ่ถึงสองแห่งคือ นิคมอุตสาหกรรมบางพลีและนิคมอุตสาหกรรมเวสโกรว์ ห่างออกไปไม่ไกลมากยังนิคมอุตสาหกรรมบางปู จึงเหมาะแก่การเป็นที่พักอาศัยไม่ว่าจะเป็นโครงการบ้านเดี่ยว บ้านแฝด บ้านมือสอง ทั้งรูปแบบปล่อยเช่าและซื้อ ขายต่างก็ได้รับความนิยมเป็นอย่างมาก
									</p>
								</template>

								<template v-else-if="content === 'poo-chao-saming-prai'">
									<h1 class="red--text">
										โครงการบ้านย่าน ปู่เจ้าสมิงพราย สมุทรปราการ ซื้อ ขาย โครงการ บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ทำเลปู่เจ้าสมิงพราย เป็นทำเลต่อเนื่องมาจากย่านแบริ่ง ลาซาล สำโรง เรียกได้ว่าเป็นทำเลที่ได้รับอานิสงส์ความคึกคักต่อเนื่องมาจากทำเลดังกล่าว และยังมีศักยภาพในการพัฒนาขึ้นไปได้อีกเรื่อยๆ จากการมีรถไฟฟ้าสถานี BTS ปู่เจ้าสมิงพรายอยู่ในพื้นที่ นอกจากนี้ยังเป็นทำเลแหล่งงาน ทำให้คนที่อยู่อาศัยในทำเลนี้ส่วนใหญ่ทำงานอยู่ในโรงงาน เช่น โตโยต้า ฮอนด้า ฮิตาชิ เป็นต้น ซึ่งมีดีมานด์ในการซื้อบ้าน คอนโด ทาวน์เฮ้าส์ในทำเลค่อนข้างมาก
									</p>
								</template>

								<template v-else-if="content === 'bang-sao-thong'">
									<h1 class="red--text">
										โครงการบ้านย่าน บางเสาธง สมุทรปราการ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										‘ทำเลบางเสาธง’ เป็นทำเลที่อยู่ติดกับย่านบางพลี จึงทำให้มีรูปแบบของลักษณะทำเลที่ใกล้เคียงกันคือเป็นพื้นที่ของแหล่งงานอุตสาหกรรม เกษตรกรรม และเป็นที่อยู่อาศัยของคนดั้งเดิม รวมถึงคนทำงานในละแวกใกล้เคียง ส่วนที่พักอาศัยใหม่อย่างบ้านเดี่ยว บ้านจัดสรร บ้านแฝด ก็มีเกิดขึ้นใหม่มากมาย จากการเข้าไปจับจองพื้นที่ของเหล่าผู้พัฒนาอสังหาฯ เนื่องจากเห็นว่าเป็นทำเลที่มีดีมานด์ และมีศักยภาพที่จะเติบโต อีกทั้งยังเป็นทำเลรองรับการขยายตัวของเมืองจากฝั่งบางนา-สำโรงอีกด้วย
									</p>
								</template>

								<template v-else-if="content === 'pracha-uthit'">
									<h1 class="red--text">
										โครงการบ้านมือสองประชาอุทิศ ทุ่งครุ ราษฎร์บูรณะ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										ประชาอุทิศ ทุ่งครุ ราชฎร์บูรณะ สุขสวัสดิ์ นับเป็นย่านที่อยู่อาศัยใหม่ที่ได้รับอิทธิพลด้านทำเลมาจากย่านพระประแดง จังหวัดสมุทรปราการมาพอสมควร ทำให้บ้านมือสองประชาอุทิศมีความเป็นที่อยู่อาศัยปะปนกับแหล่งงาน ส่วนไลฟ์สไตล์จะเน้นความเรียบง่าย แต่ก็เต็มไปด้วยศักยภาพในการพัฒนาต่อไปในอนาคตจากการเข้าถึงของรถไฟฟ้าสายสีม่วงใต้ ที่ทำให้โซนบ้านมือสองประชาอุทิศดูคึกคักขึ้นมาอย่างเห็นได้ชัด
									</p>
								</template>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 py-8 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'singlehome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'townhome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'condo'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'shophouse'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="px-6 py-0">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<div
							v-if="area"
							class="text-center red--text mt-n8 pb-4"
							style="position: relative;"
						>
							<b>เลือกทำเล</b>
						</div>
						<v-slide-group
							v-model="areaSelected"
							center-active
							show-arrows
						>
							<template #next>
								<v-icon color="rgb(237,28,36)">
									$next
								</v-icon>
							</template>
							<template #prev>
								<v-icon color="rgb(237,28,36)">
									$prev
								</v-icon>
							</template>

							<v-slide-item
								v-for="(a, i) in area"
								:key="`${locationName}-${i}`"
								:value="a.value"
							>
								<v-btn
									class="area mr-2 pa-2"
									elevation="0"
									text
									tile
									:to="a.path"
								>
									{{ a.text }}
								</v-btn>
							</v-slide-item>
						</v-slide-group>

						<v-row class="mt-3">
							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-end pl-md-0 pr-md-6"
							>
								<div class="d-flex justify-center align-center">
									<img
										src="/images/2.0/icon/bed-red.png"
										width="40"
									>
									<b class="mx-3">จำนวนห้องนอน</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 1 } }"
									>
										1
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 2 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 3 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 4 } }"
									>
										4
									</v-btn>
								</div>
							</v-col>

							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-start pl-md-6 pr-md-0"
							>
								<div class="d-flex justify-center  align-center">
									<img
										src="/images/2.0/icon/money-red.png"
										width="40"
									>
									<b class="mx-3">ราคาไม่เกิน(ล้านบาท)</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 2000000 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 3000000 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 4000000 } }"
									>
										4
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 5000000 } }"
									>
										5
									</v-btn>
								</div>
							</v-col>
						</v-row>

						<div
							v-if="empty"
							class="text-center display-3"
						>
							<br><br>
							ไม่พบข้อมูล
							<br><br><br>
						</div>
						<v-row v-else>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>
									<span>อสังหา</span>
									<span
										v-if="params.category === 'singlehome'"
										class="red--text"
									>
										บ้านเดี่ยว{{ location }}
									</span>
									<span
										v-else-if="params.category === 'townhome'"
										class="red--text"
									>
										ทาวน์โฮม{{ location }}
									</span>
									<span
										v-else-if="params.category === 'condo'"
										class="red--text"
									>
										คอนโด{{ location }}
									</span>
									<span
										v-else-if="params.category === 'shophouse'"
										class="red--text"
									>
										อาคารพาณิชย์{{ location }}
									</span>
								</h2>
							</v-col>
							<v-col
								v-for="(prop, i) in loading ? parseInt(perPage) : propertyList"
								:key="prop.id || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="loading" />
								<propertyListItem
									v-else
									:id="prop.id"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<template v-if="content === 'singlehome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านเดี่ยวสมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									"บ้านเดี่ยวสมุทรปราการ" ที่ตั้งอยู่ในย่านบางพลู บางปู และบางบ่อ นั้นกำลังได้รับความสนใจและนิยมเพิ่มขึ้นอย่างรวดเร็ว มีการขยายของ BTS ระหว่างแบริ่ง-เคหะฯ เป็นปัจจัยหลักที่ช่วยเพิ่มความน่าสนใจสู่โครงการบ้านเดี่ยวสมุทรปราการ ภายในย่านนี้มีโรงงานมากกว่า 1,000 แห่ง และหลายหมื่นพนักงาน และกับการเสร็จสิ้นการก่อสร้างทำให้บ้านเดี่ยวสมุทรปราการมีความคึกคักและพัฒนาขึ้นทุก ๆ วัน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												เราสังเกตุได้ว่า บ้านเดี่ยวสมุทรปราการ ได้รับการเปลี่ยนแปลงที่สะดุดตา ซึ่งส่งผลให้มีการปรับปรุงการใช้ชีวิต สิ่งอำนวยความสะดวก และไลฟ์สไตล์ในบ้านเดี่ยวสมุทรปราการ อย่างมาก ทำเลที่เป็นแหล่งงานที่รอบรองดี และระบบขนส่งสาธารณะที่เชื่อมต่ออย่าง BTS เป็นสิ่งที่ทำให้บ้านสมุทรปราการ มีการพัฒนาที่หมายถึงการตอบสนองต่อความต้องการของผู้คนในปัจจุบัน.
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในโซนบ้านเดี่ยวสมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mt-2 mb-0">
									บ้านเดี่ยวสมุทรปราการถือเป็นทำเลที่ยิ่งใหญ่ด้วยระบบการคมนาคมด้วยรถไฟฟ้าที่มีอยู่และที่จะมีในอนาคต ในส่วนของรถไฟฟ้าสายสีเขียว BTS ที่เชื่อมต่อแบริ่ง-เคหะฯ มีระยะทางประมาณ 13 กิโลเมตร ที่มีสถานียกระดับ 9 สถานีภายในจังหวัดสมุทรปราการ เพื่อส่งเสริมความสะดวกสบายในการเดินทางของผู้ซื้อบ้านเดี่ยวสมุทรปราการ และตรงกับมุ่งหมายของบ้านเดี่ยวสมุทรปราการที่ต้องการเพิ่มความสะดวกในการเดินทางด้วยรถไฟฟ้าที่จะมาเสริมศักยภาพทำเลในย่านนี้ รวมถึงระบบขนส่งมวลชนอื่น ๆ และเส้นทางคมนาคมอื่น ๆ ที่จะมีการปรับปรุงและเพิ่มเติมในอนาคต
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												ครอบคลุมไปถึง รถไฟฟ้าโมโนเรลสายบางปู–สุวรรณภูมิ ที่เชื่อมต่อระบบรถไฟฟ้าบีทีเอสสายสุขุมวิทกับรถไฟฟ้าเชื่อมท่าอากาศยานสุวรรณภูมิ รถไฟฟ้าสายสีเหลือง ที่เริ่มต้นจากสถานีพหลโยธิน 24 และสิ้นสุดที่สถานีสำโรง ทำให้การเดินทางของคนที่อยู่บ้านเดี่ยวสมุทรปราการไปยังเส้นลาดพร้าว ศรีนครินทร์ และเทพารักษ์ ซึ่งสะดวกและรวดเร็วมากขึ้น
											</p>
											<p>
												"บ้านเดี่ยวสมุทรปราการ" จะเป็นหัวใจของการเดินทางรวดเร็วด้วย ไฮสปีดเทรน กรุงเทพฯ-ระยอง ที่จะเชื่อมต่อทั้ง 3 สนามบินหลักของประเทศ ได้แก่ สนามบินดอนเมือง, สุวรรณภูมิ และ อู่ตะเภา ในอนาคตอันใกล้ บ้านสมุทรปราการจึงเป็นตัวเลือกที่ยอดเยี่ยมสำหรับการอยู่อาศัยที่มีความสะดวกสบายในการเดินทางไปสู่จังหวัดต่างๆ อย่างรวดเร็วและง่ายดาย
											</p>
											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์ บริเวณบ้านเดี่ยวสมุทรปราการ
											</h3>
											<p class="mt-2 mb-0">
												เพื่อความสะดวกสบายในการเดินทางด้วยรถยนต์ โซนบ้านสมุทรปราการเป็นตัวเลือกที่ดี เพราะบ้านเดี่ยวสมุทรปราการสามารถเชื่อมต่อไปสู่เมืองหลักผ่านทางถนนเส้นสำคัญมากมาย เช่น ถนนเทพารักษ์ซึ่งเชื่อมโยงถนนสุขุมวิทไปยังสำโรง, บางนา และย่านพระโขนง ถ้าคุณเดินทางผ่านแยกศรีเทพา บ้านเดี่ยวสมุทรปราการยังสามารถเชื่อมต่อไปสู่ถนนศรีนครินทร์, บางกะปิ หรือสมุทรปราการ-บางปู
											</p>
											<p class="mt-2 mb-0">
												นอกจากนี้ บ้านเดี่ยวสมุทรปราการยังมีเส้นทางด่วนบูรพาวิถีที่ทำให้คุณสามารถไปยังสุขุมวิท สีลม และสาทรได้ โดยทางด่วนนี้ยังสามารถนำคุณออกนอกเมืองไปยังชลบุรีได้อีกด้วย
											</p>
											<p>
												หรือถ้าต้องการจะเดินทางจากบ้านเดี่ยวสมุทรปราการไปสนามบินสุวรรณภูมิ, คุณสามารถใช้ถนนกิ่งแก้วและถนนเทพารักษ์ ขึ้นสะพานข้ามถนนบางนา-ตราดแล้วไปเส้นกิ่งแก้ว แล้วขึ้นสะพานอีกครั้งไปยังสนามบินสุวรรณภูมิ, จะใช้เวลาเพียงประมาณ 30 นาทีเท่านั้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต โซนบ้านเดี่ยวสมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									หากพูดถึงความสะดวกสบายในโซนบ้านเดี่ยวสมุทรปราการในอดีตอาจไม่มีมากนัก ซึ่งสิ่งอำนวยความสะดวกที่เคยมีคือ ตลาดนัด สำหรับพนักงานที่ทำงานในโรงงานอุตสาหกรรม และห้างสรรพสินค้าที่เคยมีอยู่ เช่น อิมพีเรียลสำโรง, บิ๊กซี ซูเปอร์ สมุทรปราการ, โรบินสัน ไลฟ์สไตล์ สมุทรปราการ และโลตัส สมุทรปราการ ซึ่งการมีรถไฟฟ้าและการสร้างถนนใหม่ ๆ ทำให้บ้านเดี่ยวสมุทรปราการเริ่มมีการลงทุนด้านสิ่งอำนวยความสะดวกในชีวิตประจำวันมากขึ้น โดยเริ่มจากบางนาและต่อเนื่องมาจนถึงจังหวัดสมุทรปราการ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ในปัจจุบัน บ้านเดี่ยวสมุทรปราการมีห้างสรรพสินค้าแบบ Mixed-Use ที่ใหญ่ขึ้น และมีสิ่งอำนวยความสะดวกชั้นนำอีกหลายแห่ง เช่น แบงค็อกมอลล์, เมกา ซิตี้, เดอะฟอเรสเทียส์, รร.อัสสัมชัญ สมุทรปราการ, Concordian International School , Berkeley International School และ รร.บางกอกพัฒนา. ทั้งนี้ทำให้บ้านสมุทรปราการเป็นเครื่องหมายที่ชี้ว่าการใช้ชีวิตในนี้เป็นสิ่งที่สะดวกสบายและมีคุณภาพมากยิ่งขึ้น
											</p>
											<p>
												ส่งผลให้บ้านเดี่ยวสมุทรปราการนับเป็นพื้นที่น่าพิจารณา ถ้าคุณชื่นชอบธรรมชาติและสถานที่ท่องเที่ยวเชิงอนุรักษ์ เช่น บางกระเจ้า, เมืองโบราณ, พิพิธภัณฑ์ช้างเอราวัณ, และสถานตากอากาศบางปู เป็นต้น การซื้อบ้านสมุทรปราการอาจจะเป็นคำตอบที่เหมาะสมสำหรับคนที่ต้องการที่อยู่อาศัยที่ใกล้เคียงกับตัวเมืองเพื่อความสะดวกในการเดินทางไปทำงาน บ้านเดี่ยวสมุทรปราการจึงเป็นทางเลือกที่ดี ที่ยังคงรักษาความสัมพันธ์กับธรรมชาติ เพื่อเพิ่มความผ่อนคลายในชีวิตประจำวันของคุณ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยในบ้านสมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									"บ้านเดี่ยวสมุทรปราการ" เป็นคำที่คุณจะพบก่อนอื่นในเรื่องของโครงการทางด้านอสังหาฯ ที่สมุทรปราการ ซึ่งมีหลากหลายโซนให้เลือก เช่น โซนสำโรง, โซนเมืองสมุทรปราการ, โซนเทพารักษ์, โซนสุขุมวิท - แพรกษา, โซนบางนา – ตราด และโซนบางพลี - บางบ่อ ซึ่งบ้านเดี่ยวสมุทรปราการถือเป็นทำเลที่ดีสำหรับวัยเริ่มต้นทำงานที่ต้องการโซนที่ไม่วุ่นวายมากนัก และต้องการโซนที่สะดวกสบายในการเดินทางด้วยรถไฟฟ้า
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												นอกจากนี้บ้านสมุทรปราการยังเป็นจุดที่ตรงกับความต้องการของแรงงานในภาคอุตสาหกรรมที่มาจากจังหวัดอื่น ๆ และต้องการหาที่อยู่อาศัยที่สมุทรปราการ ดังนั้นการจัดตั้งโครงการ บ้านเดี่ยวสมุทรปราการ, บ้านแฝด, บ้านมือสอง ในเขตเทพารักษ์, บางพลี - บางบ่อ ถือเป็นการตอบสนองต่อความต้องการที่มีอยู่ ทำให้คนกรุงเทพมุ่งมาที่บ้านเดี่ยวสมุทรปราการมากขึ้นในเวลานี้ เมื่อเทียบกับในอดีต และสำหรับคนที่สนใจทาวน์โฮมบางปูนี่คือย่านที่น่าสนใจอย่างยิ่งเช่นกัน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'townhome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								ทำเลทาวน์โฮม ทาวน์เฮ้าส์ ยอดนิยม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเล ทาวน์โฮม ทาวน์เฮ้าส์ ยอดนิยมในจังหวัดสมุทรปราการนั้น มีอยู่ด้วยกันหลายพื้นที่ ซึ่งแต่ละสถานที่ก็จะมีความแตกต่างและถนนสายหลักที่ใช้เชื่อมต่อทั้ง โดยทำเลยอดนิยมของการซื้อ ทาวน์โฮม ทาวน์เฮ้าส์ ได้แก่ ศรีนครินทร์, เทพารักษ์, บางพลี, บางนา-ตราด, แพรกษา, บางปู, พระประแดง, พระสมุทรเจดีย์, แบริ่ง, ลาซาล, บางบ่อ, ปู่เจ้าสมิงพราย, บางเสาธง, ประชาอุทิศ หรืออีกกลุ่มพื้นที่ที่กำลังมีอสังหาเกิดใหม่อยู่มากมาย เช่นโซน  สำโรง บางบ่อ วงแหวนรอบนอก (กาญจนาภิเษก) และ สุวรรณภูมิ เป็นต้น
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								ราคาทาวน์โฮม ทาวน์เฮ้าส์สมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ราคาทาวน์โฮม ทาวน์เฮ้าส์สมุทรปราการ โดยส่วนมากแล้ว ต่อให้เป็นอสังหาใหม่ ๆ ราคาก็จะไม่สูงมาก วัยทำงานก็สามารถเริ่มต้นซื้อ-ผ่อนได้ ขึ้นอยู่กับฟังก์ชันการใช้งาน ขนาดห้องน้ำ ห้องนอนของบ้าน และขึ้นอยู่กับการตกแต่งของโครงการในอสังหาด้วย (ตกแต่งพร้อมอยู่, ตกแต่งบางส่วน, ห้องเปล่า)
								</p>
								<p>
									สำหรับใครที่กำลังหา ทาวน์โฮมราคาไม่เกิน 2 ล้าน สมุทรปราการ หรือ ทาวน์เฮ้าส์ราคาถูก ในราคา ไม่เกิน 1.5 ล้าน เราได้รวบรวมมาให้คุณแล้ว
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนจังหวัดสมุทรปราการในปัจจุบันได้กลายเป็นแหล่งชุมชนขนาดใหญ่ ที่ตอนนี้เต็มไปด้วยสิ่งอำนวยตความสะดวก สถานที่สำคัญ มากมาย เช่น ห้างสรรพสินค้าเมกา บางนา, อิเกีย บางนา, เซ็นทรัลบางนา, แบงค็อกมอลล์, เมกา ซิตี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												โรงเรียนและมหาวิทยาลัย เช่น โรงเรียนอัสสัมชัญสมุทรปราการ รร.บดินทรเดชา (สิงห์ สิงหเสนี) สมุทรปราการ, The American School Of Bangkok (ASB), โรงเรียน นานาชาติ คอนคอร์เดียน, มหาวิทยาลัยอัสสัมชัญ, มหาวิทยาลัยหัวเฉียว หรือ โรงพยาบาล เช่น รพ.รวมชัยประชารักษ์, รพ.กรุงเทพพระประแดง, รพ.เปาโลเมโมเรียลสมุทรปราการ ฯลฯ
											</p>
											<p>
												และอีกหนึ่งสิ่งอำนวยความสะดวกในจังหวัดสมุทรปราการ ก็คือเรื่องของการเดินทางสัญจรด้วยระบบขนส่งสาธราณะอย่างรถไฟฟ้า BTS สายสีเขียวที่มีสถานีหลายสถานีที่ตัดผ่านหรืออยู่ใกล้เคียงพื้นที่ในจังหวัดสมุทรปราการ เช่น สถานี E9 BTS อ่อนนุช, E12 BTS อุดมสุข, E14 BTS แบริ่ง, E13 BTS บางนา, E7 BTS เอกมัย, E11 BTS ปุณณวิถี, BL15 MRT ลาดพร้าว, E8 BTS พระโขนง, N5 BTS อารีย์, E10 BTS บางจาก วมถึงสถานีส่วนต่อขยายใหม่ ที่เพิ่งเปิดให้บริการไปเมื่อเร็ว ๆ นี้อย่างสถานี สำโรง ปู่เจ้า ช้างเอราวัณ เคหะ สายลวด ปากน้ำ แพรกษา โรงเรียนนายเรือ ศรีนครินทร์ เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'condo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								ทำเลคอนโดยอดนิยม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเล คอนโดยอดนิยมในจังหวัดสมุทรปราการนั้น มีอยู่ด้วยกันหลายพื้นที่ ซึ่งแต่ละสถานที่ก็จะมีความแตกต่างและถนนสายหลักที่ใช้เชื่อมต่อทั้ง โดยทำเลยอดนิยมของการซื้อคอนโดสมุทรปราการ ได้แก่ ศรีนครินทร์, เทพารักษ์, บางพลี, บางนา-ตราด, แพรกษา, บางปู, พระประแดง, พระสมุทรเจดีย์, แบริ่ง, ลาซาล, บางบ่อ, ปู่เจ้าสมิงพราย, บางเสาธง, ประชาอุทิศ หรืออีกกลุ่มพื้นที่ที่กำลังมีอสังหาเกิดใหม่อยู่มากมาย เช่นโซน  สำโรง บางบ่อ วงแหวนรอบนอก (กาญจนาภิเษก) และ สุวรรณภูมิ ที่กำลังจะเป็นพื้นที่เศรษฐกิจแห่งใหม่ในย่านจังหวัดสมุทรปราการ
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								ราคาคอนโดสมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ราคาคอนโดสมุทรปราการนั้นต้องยอมรับว่า คอนโดราคาถูก ไม่เกิน 1.5 ล้าน จะสามารถหาได้โดยทั่วไป ทั้งอสังหาใหม่ สร้างเสร็จในปี 2565 , 2564 เพราะพื้นที่ทำเลของสมุทรปราการจะมีราคาที่ถูกกว่ากรุงเทพอยู่แล้ว แต่ทั้งนี้จะขึ้นอยู่กับฟังก์ชันการใช้งาน ขนาดห้องทั้งหมด กี่ตารางเมตร จำนวนห้องน้ำ, ห้องนอนของคอนโด และขึ้นอยู่กับการตกแต่งของโครงการในอสังหาด้วย (ตกแต่งพร้อมอยู่, ตกแต่งบางส่วน, ห้องเปล่า)
								</p>
								<p>
									หรือถ้าอสังหาโครงการไหนที่เป็นโครงการคอนโดที่ เจ้าของขายเอง ก็อาจจะสามารถต่อรองราคาให้อยู่ในเรทที่คุณพอใจได้ แต่สำหรับใครที่มองหาคอนโดราคาไม่เกิน 2 ล้าน สมุทรปราการ เราได้รวบรวมไว้ให้คุณแล้ว
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนจังหวัดสมุทรปราการในปัจจุบันได้กลายเป็นแหล่งชุมชนขนาดใหญ่ ที่ตอนนี้เต็มไปด้วยสิ่งอำนวยตความสะดวก สถานที่สำคัญ มากมาย เช่น ห้างสรรพสินค้าเมกา บางนา, อิเกีย บางนา, เซ็นทรัลบางนา, แบงค็อกมอลล์, เมกา ซิตี้, ศูนย์การแสดงสินค้าไบเทค บางนา
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												อีกทั้งในโซนจังหวัดสมุทรปราการยังมี รถไฟฟ้า BTS สายสีเขียวหลายสถานีที่ตัดผ่านหรืออยู่ใกล้เคียงพื้นที่ในจังหวัดสมุทรปราการ เช่น สถานี E9 BTS อ่อนนุช, E12 BTS อุดมสุข, E14 BTS แบริ่ง, E13 BTS บางนา, E7 BTS เอกมัย, E11 BTS ปุณณวิถี, BL15 MRT ลาดพร้าว, E8 BTS พระโขนง, N5 BTS อารีย์, E10 BTS บางจาก วมถึงสถานีส่วนต่อขยายใหม่ ที่เพิ่งเปิดให้บริการไปเมื่อเร็ว ๆ นี้อย่างสถานี สำโรง ปู่เจ้า ช้างเอราวัณ เคหะ สายลวด ปากน้ำ แพรกษา โรงเรียนนายเรือ ศรีนครินทร์ เป็นต้น
											</p>
											<p>
												อีกทั้งยังรายล้อมไปด้วยสถานศึกษาและโรงพยาบาลชั้นนำ เช่น โรงเรียนอัสสัมชัญสมุทรปราการ รร.บดินทรเดชา (สิงห์ สิงหเสนี) สมุทรปราการ, โรงเรียนราชวินิตบางแก้ว, The American School Of Bangkok (ASB), โรงเรียน นานาชาติ คอนคอร์เดียน, มหาวิทยาลัยอัสสัมชัญ (แอแบค), มหาวิทยาลัยหัวเฉียว หรือ โรงพยาบาล เช่น รพ.รวมชัยประชารักษ์, รพ.กรุงเทพพระประแดง, รพ.เปาโลเมโมเรียลสมุทรปราการ, รพ.พริ้นซ์ สุวรรณภูมิฯลฯ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'shophouse'">
							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								ทำเลอาคารพาณิชย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเล อาคารพาณิชย์สมุทรปราการนั้น มีอยู่ด้วยกันหลายพื้นที่ ซึ่งแต่ละสถานที่ก็จะมีข้อดีในการเดินทาง และความสะดวกสบาย ที่แตกต่างกันออกไป โดยทำเลยอดนิยมของการซื้ออาคารพาณิชย์สมุทรปราการ ได้แก่ ศรีนครินทร์, เทพารักษ์, บางพลี, บางนา-ตราด, แพรกษา, บางปู, พระประแดง, พระสมุทรเจดีย์, แบริ่ง, ลาซาล, บางบ่อ, ปู่เจ้าสมิงพราย, บางเสาธง, ประชาอุทิศ หรืออีกกลุ่มพื้นที่ที่กำลังมีอาคารพาณิชย์เกิดใหม่อยู่มากมาย เช่นโซน  สำโรง บางบ่อ วงแหวนรอบนอก (กาญจนาภิเษก) และ สุวรรณภูมิ เป็นต้น
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								ราคาอาคารพาณิชย์สมุทรปราการ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ราคาอาคารพาณิชย์สมุทรปราการ โดยส่วนมากแล้ว ต่อให้เป็นอาคารใหม่ราคาก็จะไม่สูงมาก สามารถเริ่มต้นซื้อ-ผ่อนได้ ขึ้นอยู่กับฟังก์ชันการใช้งาน ขนาดห้องน้ำ ห้องนอนของบ้าน และขึ้นอยู่กับการตกแต่งของโครงการในอสังหาด้วย (ตกแต่งพร้อมอยู่, ตกแต่งบางส่วน, ห้องเปล่า) หรือถ้าเป็นอาคารพาณิชย์ที่ เจ้าของขายเอง ก็อาจจะมาพร้อมการตกแต่งที่ครบถ้วนหรือสามารถต่อรองราคาลงได้อีก
								</p>
								<p>
									สำหรับใครที่กำลังหา อาคารพาณิชย์ราคาไม่เกิน 2 ล้าน สมุทรปราการ, อาคารพาณิชย์ราคาถูก, ไม่เกิน 1.5 ล้าน เราได้รวบรวมมาให้คุณแล้ว
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนจังหวัดสมุทรปราการในปัจจุบันได้กลายเป็นแหล่งชุมชนขนาดใหญ่ ที่ตอนนี้เต็มไปด้วยสิ่งอำนวยความสะดวก สถานที่สำคัญทั้งเก่าและใหม่มากมาย เช่น ห้างสรรพสินค้าเมกา บางนา, อิเกีย บางนา, เซ็นทรัลบางนา, แบงค็อกมอลล์, เมกา ซิตี้ และไบเทค บางนา
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												โรงเรียนและมหาวิทยาลัย เช่น โรงเรียนอัสสัมชัญสมุทรปราการ รร.บดินทรเดชา (สิงห์ สิงหเสนี) สมุทรปราการ, The American School Of Bangkok (ASB), โรงเรียนราชวินิตบางแก้ว, โรงเรียน นานาชาติ คอนคอร์เดียน, มหาวิทยาลัยอัสสัมชัญ, มหาวิทยาลัยหัวเฉียว หรือ โรงพยาบาล เช่น รพ.รวมชัยประชารักษ์, รพ.กรุงเทพพระประแดง, รพ.พริ้นซ์ สุวรรณภูมิ, รพ.เปาโลเมโมเรียลสมุทรปราการ ฯลฯ
											</p>
											<p>
												และอีกหนึ่งสิ่งอำนวยความสะดวกในจังหวัดสมุทรปราการ ก็คือเรื่องของการเดินทางสัญจรด้วยรถไฟฟ้า BTS สายสีเขียวที่มีสถานีหลายสถานีที่ตัดผ่านหรืออยู่ใกล้เคียงพื้นที่ในจังหวัดสมุทรปราการ เช่น สถานี E9 BTS อ่อนนุช, E12 BTS อุดมสุข, E14 BTS แบริ่ง, E13 BTS บางนา, E7 BTS เอกมัย, E11 BTS ปุณณวิถี, BL15 MRT ลาดพร้าว, E8 BTS พระโขนง, N5 BTS อารีย์, E10 BTS บางจาก วมถึงสถานีส่วนต่อขยายใหม่ ที่เพิ่งเปิดให้บริการไปเมื่อเร็ว ๆ นี้อย่างสถานี สำโรง ปู่เจ้า ช้างเอราวัณ เคหะ สายลวด ปากน้ำ แพรกษา โรงเรียนนายเรือ ศรีนครินทร์ เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'srinakarin'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านย่านศรีนครินทร์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับคนที่สนใจโครงการบ้านย่าอ่อนนุช-ศรีนครินทร์-บางนา-อ่อนนุช ซึ่งเป็นทำเลในฝั่งตะวันออกของกรุงเทพมหานคร ที่รายล้อมไปด้วยสิ่งอำนวยความสะดวกครบครัน และการเดินทางสามารถที่เชื่อมต่อได้หลากหลายเส้นทาง รวมทั้งอัตราราคาที่ดินไม่สูงมากเมื่อเทียบกับทำเลย่านสุขุมวิทตอนกลาง อย่าง อโศก ทองหล่อ มาดูกันดีกว่าว่า ทำเลนี้มีอะไรที่น่าสนใจสำหรับการใช้ชีวิตและการลงทุนซื้อบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม หรือคอนโดในย่านนี้บ้าง ไปดูพร้อมๆ กันเลย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านศรีนครินทร์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									ความเจริญมักกระจายตัวตามระบบการคมนาคม รวมถึงระบบขนส่งสาธารณะ แน่นอนว่า เมื่อมีรถไฟฟ้า BTS สายสีเขียวส่วนต่อขยายช่วงอ่อนนุช-แบริ่ง ซึ่งสร้างแล้วเสร็จมาตั้งแต่ปี 2554 ตัดผ่านในทำเลโซนอ่อนนุชไปจนถึงบางนา-แบริ่งก็ทำให้ทำเลย่านศรีนครินทร์นี้ กลายเป็น Hub ใหม่ของการอยู่อาศัย อีกทั้งในปี 2561 ที่ผ่านมารถไฟฟ้าสายสีก็ขยายตัวไปสู่จังหวัดสมุทรปราการ ยิ่งทำให้ภาพรวมของการเดินทางเข้า-ออกเมืองของคนในฝั่งแถบตะวันออกของกรุงเทพฯ ดูสะดวกสบายมากขึ้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												นอกจากนี้ในอนาคตก็จะมีรถไฟฟ้าสายใหม่ที่เข้ามาเชื่อมต่อทำให้การอยู่อาศัยและการเดินทางไปยังโซนอื่นๆ ของกรุงเทพฯ รวดเร็วขึ้น เช่น
											</p>
											<ul>
												<li>
													<b>รถไฟฟ้า Light Rail สายบางนา-สุวรรณภูมิ</b> หรือที่หลายคนเรียกว่า รถไฟฟ้าสายสีฟ้าอ่อนจะวิ่งอยู่เส้นถนนบางนา-ตราด (ถนนเทพรัตน) เริ่มตั้งแต่หัวถนนตรงแยกบางนา ยาวไปจนถึงทางเข้าสนามบินสุวรรณภูมิ มีทั้งหมด 14 สถานี และสถานี BTS บางนาจะกลายเป็นสถานี Interchange ของรถไฟฟ้าสายนี้อีกด้วย
												</li>
												<li>
													<b>รถไฟฟ้าสายสีเหลือง</b> มีจุดเริ่มต้นจากบริเวณแยกรัชดา-ลาดพร้าว และมีจุดตัดกับรถไฟฟ้าสายสีส้มที่สถานีมีนบุรี แอร์พอร์ตลิงค์ที่สถานีหัวหมาก และสถานี BTS สำโรง
												</li>
											</ul>

											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ส่วนการเดินทางด้วยรถยนต์ในย่านศรีนครินทร์ บางนา อ่อนนุช สามารถเดินทางได้สะดวก โดยในแต่ละโซนมีถนนเส้นหลักและทางด่วนที่เชื่อมต่อเพื่อเข้า-ออกเมืองได้หลายเส้นทาง
											</p>
											<ul>
												<li>
													<b>ย่านศรีนครินทร์</b> - หากต้องการออกนอกเมืองสามารถใช้ถนนพระราม 9 ตัดถนนศรีนครินทร์ ไปเข้าถนนกรุงเทพกรีฑาผ่านทางถนนเลียบมอเตอร์เวย์กรุงเทพฯ-ชลบุรีได้ หรือถ้าหากต้องการเข้าเมืองก็ใช้ถนนหัวหมากเข้าสู่ย่านชุมชนบนถนนรามคำแหง เข้าพระราม 9 หรือเลี้ยวซ้ายและมุ่งหน้าสู่แยกลำสาลีเพื่อเดินทางไปแยกบางกะปิได้ หรือถ้าต้องการเข้าเมืองเร็วขึ้นสามารถใช้ทางด่วนพระราม 9 ตรงเข้าสู่เมืองได้เลยเช่นเดียวกัน
												</li>
												<li>
													<b>ย่านบางนา</b> - ใช้ถนนเส้นหลักอย่างสุขุมวิทเพื่อวิ่งเข้าเมืองหรือวิ่งออกนอกเมืองได้สบายๆ นอกจากนี้มีถนนที่ตัดผ่านอีกหลายเส้น เช่น ถนนบางนา-ตราด ถนนลาซาล ถนนแบริ่ง ซึ่งเป็นถนนที่เชื่อมย่านศรีนครินทร์และเส้นสุขุมวิทเข้าไว้ด้วยกัน
												</li>
												<li>
													<b>ย่านอ่อนนุช</b> - เป็นย่านที่อยู่ก่อนจะถึงโซนบางนาเป็นโซนที่เดินทางสะดวก เพราะสามารถเชื่อมต่อกับซอยหรือถนนสายอื่นๆ อาทิ พระโขนง เพชรบุรี พัฒนาการ และศรีนครินทร์ ผ่านซอยลัด ซอยย่อยได้ค่อนข้างมากเลยทีเดียว
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้านสิ่งอำนวยความสะดวกมีให้ครบทั้งใหม่และเก่า ไม่ว่าจะเป็นสถานศึกษา โรงพยาบาล ห้างสรรพสินค้า หรือแม้กระทั่งพื้นที่สีเขียว อาทิ ย่านศรีนครินทร์ซึ่งประกอบด้วยโซนที่อยู่อาศัยหลายโซนด้วยกัน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												อย่างเช่น <b>โซนศรีนครินทร์–ร่มเกล้า</b>ที่เต็มไปด้วยแหล่งรวมไลฟ์สไตล์อย่างซีคอนสแควร์ ศรีนครินทร์, พาราไดร์ พาร์ค และเดอะไนน์พระราม 9 ส่วนด้านสถานศึกษาก็เต็มไปด้วยสถาบันนานาชาติอย่าง Brighton College Bangkok, Stamford University และ Assumption University
											</p>
											<p class="mb-0">
												<b>โซนศรีนครินทร์ ช่วงลำสาลี-กรุงเทพกรีฑา</b> ที่ในอนาคตจะมี Mix-used เข้ามาเปิดตัวใหม่อย่างโครงการเมเจอร์ทาวเวอร์ พระราม 9 - รามคำแหง ซึ่งมีพื้นที่กว่า 25,000 ตารางเมตร และมีการรีโนเวทเดอะมอลล์ รามคำแหง 2 ใหม่ ทำให้ย่านนี้ในอนาคตจะกลายเป็นพื้นที่สำนักงานรวมกับไลฟ์สไตล์ใช้ชีวิตที่ลงตัวมากขึ้น
											</p>
											<p>
												<b>โซนศรีนครินทร์ - พัฒนาการ</b> โดดเด่นในเรื่องของทำเลที่ยังคงมีความเป็นเมือง แต่ก็ยังให้ความสำคัญกับพื้นที่สีเขียว จึงเหมาะสำหรับคนรักสุขภาพที่ต้องการชีวิตที่รายล้อมด้วยต้นไม้จากพื้นที่สีเขียวถึง 3 สวนสาธารณะ ได้แก่ สวนหลวงร.9, โครงการป่าในกรุง, ศูนย์กีฬาทางน้ำบึงหนองบอน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านศรีนครินทร์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ด้านการพัฒนาของทำเล แน่นอนว่า เมื่อรถไฟฟ้าสายต่างๆ สร้างเสร็จทำเลรอบๆ รถไฟฟ้าในแถบศรีนครินทร์- บางนา ย่อมปรับตัวสูงขึ้นรวมถึงน่าจะมีดีเวลลอปเปอร์อีกหลายรายที่เตรียมจะพัฒนาโครงการคอนโดราคาถูก เพื่อตอบโจทย์ดีมานด์ย่านชานเมืองฝั่งตะวันออก ที่ตอนนี้เป็นตลาดแนวราบอย่างบ้านเดี่ยว บ้านมือสอง ทาวน์โฮมราคาปานกลางถึงสูง ซึ่งจะเห็นได้ชัดเจนว่า ย่านศรีนครินทร์จะเติบโตไปกลายเป็น Hub ที่อยู่อาศัยใกล้เคียงกันย่านอ่อนนุช ซึ่งตอนนี้ค่อนข้างเจริญมาก สามารถซื้ออสังหาฯ เพื่ออยู่อาศัยและทำกำไรสำหรับการลงทุนซื้อหรือปล่อยเช่าได้ค่อนข้างดี
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'thepharak'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านย่านเทพารักษ์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									เมื่อพูดถึงโครงการบ้านเทพารักษ์ นับเป็นย่านที่มีบ้านเดี่ยว บ้านมือสองแนวราบที่ได้รับความนิยมสูงเป็นอันดับต้นๆ ของจังหวัดสมุทรปราการ ทำให้มีบ้านแนวราบหนาแน่นและคึกคัก ทั้งทาวน์โฮม บ้านแฝด และบ้านเดี่ยว ทั้งมีหนึ่งและมือสอง โดยราคาทาวน์โฮมจะอยู่ที่ประมาณ 2-3 ล้านบาท บ้านแฝดราคาประมาณ 3 ล้านบาทขึ้นไป ส่วนบ้านเดี่ยวระดับราคาจะอยู่ที่ 5 - 7 ล้านบาทขึ้นไป ส่วนเหตุนั้นเป็นเพราะศักยภาพของทำเลที่สนับสนุนการใช้ชีวิต การเดินทาง และมีแนวโน้มที่จะพัฒนาต่ออีกมาก ดังต่อไปนี้
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านเทพารักษ์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									เป็นย่านที่สามารถโดยสารรถไฟฟ้าสายสีเขียวส่วนต่อขยาย BTS ที่สร้างต่อมาจากสถานีแบริ่ง วิ่งตรงสู่จังหวัดสมุทรปราการจนถึงสถานีเคหะฯ ซึ่งถ้าเลือกซื้อบ้านอยู่ในโซนต้นๆ ของถนนเทพารักษ์ไปจนถึงแยกศรีเทพา สามารถนั่งรถสองแถวหรือวินมอเตอร์ไซค์ เพื่อมาขึ้นรถไฟฟ้าได้โดยใช้ระยะเวลาไม่กี่นาที แถมในอนาคตรถไฟฟ้าเส้นนี้จะขยายต่อไปถึงสถานีบางปู ซึ่งก็เป็นทั้งย่านที่อยู่อาศัยและแถบท่องเที่ยวเชิงธรรมชาติของจังหวัดสมุทรปราการอีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												นอกจากรถไฟฟ้าสายสีเขียวส่วนต่อขยายอย่าง BTS แล้วก็ยังมีรถไฟฟ้าสายสีเหลือง (ลาดพร้าว-สำโรง) ที่จะวิ่งตัดผ่านย่านเทพารักษ์โดยตรงในแถบสถานีทิพวัล และสถานีศรีเทพา และถ้านั่งไปสุดสายก็จะเป็นสถานีสำโรง ซึ่งเป็นสถานี Interchange ระหว่างรถไฟฟ้าสายสีเหลืองและ BTS ในปัจจุบัน
											</p>
											<p>
												ส่วนการเดินทางออกสู่ต่างจังหวัดหรือจะไปต่างประเทศในอนาคตก็จะมีโครงการสร้างไฮสปีดเทรน กรุงเทพฯ-ระยอง และรถไฟฟ้าโมโนเรล สายบางปู–สุวรรณภูมิเพิ่มเติมในโซนฝั่งตะวันออกของกรุงเทพมหานครด้วย แน่นอนว่า ทำเลนี้จึงเหมาะทั้งกับคนในพื้นที่ และคนที่ต้องเดินทางไปมาทั้งในประเทศและนอกประเทศอีกด้วย
											</p>

											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ด้านการเดินทางด้วยรถยนต์ก็ถือว่าเป็นย่านที่เดินทางสะดวกเนื่องจากเป็นย่านที่เชื่อมต่อไปยังถนนเส้นสำคัญได้หลายทาง เช่น ถนนสุขุมวิท ทำให้สามารถเชื่อมต่อไปยังกรุงเทพตอนบนและตอนกลางได้อย่างสะดวกสบาย, ตัวถนนเทพารักษ์เองก็เชื่อมต่อไปทางฝั่งสำโรงได้ และถ้าขับผ่านแยกศรีเทพาก็จะเชื่อมไปยังถนนศรีนครินทร์ออกไปยังย่านบางกะปิได้อย่างสะดวก หรือถ้าต้องการเดินทางไปทางฝั่งพระราม 2 - บางนา สามารถใช้ทางพิเศษกาญจนาภิเษกได้เลย  หรือจะเลือกใช้ทางด่วนรามอินทรา-อาจณรงค์ ทางด่วนศรีรัชฯ ในการเข้า-ออกเมืองได้ ก็สะดวกสบายไม่แพ้กัน
											</p>
											<p>
												ส่วนทางฝั่งออกนอกเมืองใช้ถนนกิ่งแก้ว เพื่อไปบางพลี ลาดกระบัง และท่าอากาศยานสุวรรณภูมิได้ใช้เวลาเดินทางประมาณ 30 นาทีเท่านั้น หรือจะเลือกออกไปมอเตอร์เวย์เพื่อเข้าเมืองโซนศรีนครินทร์ รามคำแหง หรือออกนอกเมืองไปชลบุรีก็เดินทางไปได้ด้วยเช่นกัน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้วยความเป็นแหล่งงานขนาดใหญ่ ทำให้ผู้พัฒนามองเห็นศักยภาพของทำเลเทพารักษ์นี้ และต่างเข้ามาจับจองพื้นที่ เพื่อสร้างเป็นโครงการแนวราบและแนวสูงมากมาย เรียกว่ามีครบทั้งบ้านเดี่ยว บ้านมือสอง ทาวน์โฮมและคอนโดในหลากหลายระดับราคา
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												ซึ่งถ้าใครสนใจจะซื้อบ้าน หรือที่อยู่อาศัยแนวราบอื่นๆ ส่วนใหญ่จะตั้งอยู่ในโซนเทพารักษ์-สุวรรณภูมิที่เป็นช่วงถนนเทพารักษ์ตอนกลางไปจนถึงปลาย ซึ่งมีพื้นที่ขนาดใหญ่ให้พัฒนาโครงการบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม หรืออาคารพาณิชย์เหลืออยู่ค่อนข้างมาก ส่วนด้านราคาก็ยังถือว่าจับต้องได้ เหมาะกับคนวัยทำงานหรือสร้างครอบครัวตั้งแต่ช่วงเริ่มต้นไปจนถึงระดับครอบครัวใหญ่ เริ่มกันตั้งแต่หลักล้านต้นๆ ไปจนถึงระดับหลัก 10 ล้านบาทก็มี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bang-phli'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านเดี่ยวบางพลี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับผู้ที่กำลังสนใจ บ้านเดี่ยวบางพลี ไม่ว่าจะเป็นการซื้อบ้านเดี่ยว บ้านมือสอง หรือแม้แต่การค้นหาบ้านเช่าในย่านนี้ คุณจะพบว่าราคาบ้านเดี่ยวบางพลีมักจะถูกกว่าโซนอื่น ๆ ในจังหวัดสมุทรปราการและแถบกรุงเทพฯ ชานเมือง ซึ่งบ้านเดี่ยวบางพลีในแถบนี้ถูกกว่าโซนบางนาประมาณ 20-30%, ซึ่งทำให้บ้านบางพลี-บางบ่อเป็นย่านที่รองรับการขยายตัวของเมืองจากย่านอ่อนนุช-สำโรงอย่างมาก จึงทำให้บ้านเดี่ยวบางพลีสามารถเปรียบเทียบได้กับย่านบางนาหรือบางเขน ซึ่งเป็นย่านชานเมืองที่พัฒนามาก่อนหน้านี้ รวมถึงย่านนวมินทร์หรือลาดพร้าวเช่นกัน
								</p>
								<p>
									เพื่อให้คุณได้เห็นภาพครบถ้วนเกี่ยวกับบ้านเดี่ยวบางพลี มาลองดูศักยภาพของทำเลในย่านนี้กันว่า มีอะไรที่น่าสนใจบ้าง ทั้งในด้านการเดินทาง, การใช้ชีวิตประจำวัน, ภาพรวมของทำเลและที่อยู่อาศัยที่มีให้เลือกในบ้านเดี่ยวบางพลี
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								บ้านเดี่ยวบางพลี กับการเดินทาง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									การเดินทางด้วยรถไฟฟ้าในย่านบ้านเดี่ยวบางพลีกำลังเป็นที่นิยมขึ้นอย่างรวดเร็ว  เพราะการเดินทางด้วยรถไฟฟ้า BTS สายสีเขียวที่เดินทางจากสถานีแบริ่งไปยังสถานีเคหะฯ เป็นทางเลือกใกล้ที่สุดสำหรับผู้ที่อยู่ในบ้านเดี่ยวบางพลี  ใโดยนอนาคตได้มีแผนการก่อสร้างรถไฟฟ้านี้จะยืดยาวไปถึงสถานีบางปู นอกจากนี้ยังมีรถไฟฟ้าสายสีเหลือง (ลาดพร้าว-สำโรง) ที่กำลังรอเปิดให้บริการแล้ว การสร้างสถานีที่ผ่านโซนบ้านเดี่ยวบางพลี ที่หนามแดง-บางพลี ก็กำลังจะมาในเร็ว ๆ นี้อีกด้วย ซึ่งสถานีที่ใกล้ที่สุดสำหรับบ้านเดี่ยวบางพลีคือ สถานีศรีด่าน ซึ่งตั้งอยู่บริเวณปากซอยฝั่งถนนศรีนครินทร์.
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												สำคัญที่สุดคือ รถไฟฟ้าสายสีเหลืองนี้จะขยายระบบเดินทางไปจนถึงรถไฟฟ้า BTS สายสีเขียวที่สถานีสำโรง ด้วยเหตุผลนี้ทำให้การเดินทางไปยังโซนต่างๆ ในกรุงเทพฯ สำหรับผู้ที่อยู่ในบ้านเดี่ยวบางพลีและแถบชานเมืองสามารถทำได้อย่างรวดเร็วมากขึ้น และในอนาคตอันใกล้ บ้านเดี่ยวบางพลี จะได้รับประโยชน์มากขึ้นนื่องจากโครงการรถไฟฟ้าความเร็วสูงที่เชื่อมต่อ 3 สนามบินหลัก, สนามบินดอนเมือง, สนามบินสุวรรณภูมิ และสนามบินอู่ตะเภา ผ่านรถไฟฟ้ารางไฮสปีดเทรน กรุงเทพฯ-ระยอง สำหรับผู้ที่อาศัยอยู่ในบ้านเดี่ยวบางพลี การเดินทางจากสนามบินจะกลายเป็นเรื่องง่ายดายและเรายังมีโครงการรถไฟฟ้ารางคู่ขนาดเบาที่เชื่อมต่อสายบางนา-สนามบินสุวรรณภูมิ โดยมีการเชื่อมต่อกับรถไฟฟ้าสายสุขุมวิท จากสี่แยกบางนาไปยังสนามบินนานาชาติสุวรรณภูมิ ผ่านมากกว่า 12 สถานี ประโยชน์ทางการเดินทางที่เพิ่มขึ้นนี้จะเพิ่มค่ามูลของบ้านเดี่ยวบางพลี และทำให้เขตนี้มีศักยภาพในการพัฒนาสูงขึ้น
											</p>

											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์ บริเวณบ้านเดี่ยวบางพลี
											</h3>
											<p class="mb-0">
												สำหรับผู้ที่อาศัยอยู่บริเวณบ้านเดี่ยวบางพลี แม้จะมีความสะดวกในการเดินทางด้วยรถไฟฟ้า แต่การเดินทางบนท้องถนนก็ยังเป็นวิธีการสัญจรหลักสำหรับคนส่วนใหญ่ ซึ่งผู้คนย่านบ้านเดี่ยวบางพลีมักใช้ถนนหลักและเส้นทางลัดเลาะตามซอยต่างๆ ในการเดินทาง หากต้องการเดินทางไปยังถนนศรีนครินทร์ และถนนบางนา-ตราด ก็สามารถใช้ซอยศรีด่าน 22 และซอยวัดคลองปลัดเปรียง
											</p>
											<p>
												โดยที่บ้านเดี่ยวบางพลี การเดินทางบนถนนเส้นหลักนั้น มีหลากหลายเส้นทางที่เชื่อมต่อไปยังกรุงเทพมหานคร ส่วนใหญ่ผู้คนที่อาศัยที่บ้านเดี่ยวบางพลีมักจะใช้ถนนตำหรุ-กิ่งแก้ว และวงแหวนกาญจนาฯ เมื่อเดินทางเข้าเมืองไปทำงานตอนเช้าและกลับบ้านในตอนเย็น ซึ่งในฝั่งขาออกเมืองก็สามารถใช้ถนนตำหรุ-บางพลีที่เชื่อมโซนบางปู และถนนกิ่งแก้วที่เชื่อมไปบางนา-ตราด และลาดกระบัง เพื่อหลีกเลี่ยงการจราจรติดได้ หรือถ้าคุณต้องการเดินทางไปชลบุรี ทางด่วนบูรพาวิถีจึงเป็นทางเลือกที่ดี เพียงขับตรงไปเรื่อยๆ ใช้เวลาไม่กี่ชั่วโมงก็ถึงที่หมายแล้ว
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต โซนบ้านเดี่ยวบางพลี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนบ้านเดี่ยวบางพลี - บางบ่อ จะทำให้คุณสัมผัสถึงสภาพแวดล้อมที่หลากหลายและน่าอยู่ เพราะบ้านเดี่ยวบางพลีเป็นแหล่งที่อยู่อาศัยที่เต็มปด้วยทาวน์โฮม, คอนโด และอพาร์ตเมนต์ที่เหมาะสมสำหรับคนทำงานในนิคมอุตสาหกรรม ทั้งซื้อและเช่าครบวงจร ในบ้านบางพลีคุณจะพบว่ามีลักษณะการใช้ชีวิตที่ตรงตามความต้องการอันแตกต่างออกไป ถ้าคุณต้องการชีวิตที่รวมทั้งสิ่งอำนวยความสะดวกและแหล่งช้อปปิ้ง โซนตำหรุ-บางพลีคือคำตอบ ซึ่งมีเส้นทางเชื่อมต่อถนนเทพารักษ์และถนนบางนา-ตราดเป็นทางลัดที่ง่ายสำหรับการเดินทาง
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ทั้งนี้บ้านเดี่ยวบางพลียังให้ความสะดวกสบายในการเดินทางไปยังศูนย์การค้า Big C และตลาดใหญ่ๆ อื่นๆ บนถนนเทพารักษ์ ที่สามารถเดินทางไปช็อป ชิม ชิลล์กันได้ตามอัธยาศัย
											</p>
											<p>
												หากคุณกำลังมองหาบ้านเดี่ยวบางพลีที่ใกล้กับสถานที่ท่องเที่ยวที่ผ่อนคลายในธรรมชาติ อาทิเช่น บางกระเจ้า, บางปู และสกายเลน บ้านเดี่ยวบางพลีสามารถตอบสนองความต้องการของคุณได้ทุกประการ และในอนาคตบ้านบางพลี-บางบ่อ จะกลายเป็นย่านที่ใกล้กับสำนักงานใหญ่, อาคารสำนักงานเกรดเอ, ห้างค้าปลีก และเมกะโปรเจ็กต์ใหญ่โตที่กำลังอยู่ในระหว่างการก่อสร้าง เช่น AIA East Gateway, โครงการ Bangkok Mall, The Forestias และอื่น ๆ อีกมากมาย ทำให้บ้านบางพลีจะเป็นย่านที่เจริญเติบโตมากขึ้นในด้านไลฟ์สไตล์และมีความหลากหลาย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านบ้านบางพลี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านบางพลี-บางบ่อนับเป็นอีกหนึ่งทำเลที่น่าจับตามองทั้งในแง่ผู้ซื้อ นักลงทุน และผู้พัฒนาอสังหาริมทรัพย์ เนื่องจากมีแหล่งงานและแหล่งธุรกิจตั้งอยู่ค่อนข้างมาก แถมยังเดินทางเข้าเมืองสะดวก ทำให้มีดีมานด์ความต้องการที่อยู่อาศัยสูง ซึ่งในแต่ละโซนก็มีเอกลักษณ์ทางด้านทำเลที่เหมาะสำหรับผู้อยู่อาศัยที่ค่อนข้างแตกต่างกัน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>
													<b>โซนหนามแดง-บางพลี</b> จะเหมาะกับคนที่ทำงานในเมืองและต้องใช้รถใช้ถนนเส้นสำคัญในการเดินทาง เช่น ถนนศรีนครินทร์ ถนนบางนา-ตราด ถนนสุขุมวิท และถนนวงแหวนกาญจนาภิเษก นอกจากนี้ยังเป็นกลุ่มคนที่ต้องการซื้อบ้านเดี่ยวบางพลี ที่สามารถเดินทางด้วยรถไฟฟ้าสายสีเหลืองได้ด้วย
												</li>
												<li>
													<b>โซนตำหรุ-บางพลี</b> จะเป็นโซนตลาดใหม่ของบ้านเดี่ยวบางพลี จึงเป็นทางเลือกให้กับกลุ่มคนรุ่นใหม่ที่กำลังมองหาบ้านเดี่ยวพื้นที่ใช้สอยคุ้มค่าในราคาที่จับต้องได้ และเหมาะเป็นอย่างยิ่งสำหรับคนที่ทำงานในแถบนิคมบางพลี/นิคมบางปู และโรงงานต่างๆ ที่อยู่บนถนนตำหรุ-กิ่งแก้ว และเหมาะกับคนที่ทำงานในสนามบินสุวรรณภูมิ เพราะเดินทางไปได้สะดวกเป็นอย่างมากอีกด้วย
												</li>
												<li>
													<b>โซนบางบ่อ</b> จะเป็นโซนสุดท้ายของสมุทรปราการ อยู่ติดกับฉะเชิงเทราจึงเหมาะกับคนที่อยากใช้ชีวิตในแถบชานเมือง และมีธุระที่ต้องเดินทางไปยังฉะเชิงเทรา-ชลบุรีอยู่บ่อยๆ แต่ก็ยังต้องการทำเลบ้านที่ราคาไม่สูง และเดินทางเพื่อเข้าเมืองง่ายอีกด้วย
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bangna-trad'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านมือสองบางนา-ตราด
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านมือสองย่านบางนา-ตราดเจริญเติบโตขึ้นต่อเนื่อง ทั้งจากการเป็นเส้นทางที่เชื่อมถนนเส้นหลักหลายสายเข้าไว้ด้วยกันทำให้เดินทางได้สะดวก มีการผ่านของเส้นทางรถไฟฟ้า BTS บริเวณจุดเริ่มต้นของถนนเส้นบางนา-ตราด มีการสร้าง Mega Project อย่างห้างสรรพสินค้าและ Mix-Used มากมาย อีกทั้งการเปิดใช้บริการสนามบินสุวรรณภูมิตั้งแต่ปี 2549 ก็ยิ่งทำให้ย่านบ้านมือสองบางนา-ตราด กลายเป็นแหล่งงาน แหล่งไลฟ์สไตล์ และแหล่งที่อยู่อาศัยหลากหลายระดับ ทั้งบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม และโครงการหมู่บ้านต่างๆ ทำให้โซนบ้านมือสองบางนา - ตราด มีศักยภาพทำเลที่เหนือกว่าโซนอื่นๆ ที่อยู่ในจังหวัดสมุทรปราการด้วยกันค่อนข้างมาก
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านบ้านมือสองบางนา-ตราด
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									สำหรับการเดินทางด้วยรถไฟฟ้าในย่านบางนา-ตราด ในปัจจุบันสามารถใช้รถไฟฟ้า BTS สายสีเขียวซึ่งเป็นรถไฟฟ้าในแนวเหนือ-ใต้ของกรุงเทพฯ ที่วิ่งจากฝั่งลำลูกกาในจังหวัดปทุมธานี ผ่านดอนเมือง พหลโยธิน ผ่านย่านใจกลางเมืองอย่างอโศก ทองหล่อ อ่อนนุชมาจนถึงฝั่งบางนา-ตราดเลยไปถึงสมุทรปราการเลยทีเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ส่วนในอนาคตอันใกล้นี้ก็จะมีรถไฟฟ้าสายสีเหลือง (ลาดพร้าว-สำโรง) ซึ่งจะตัดผ่านเส้นบางนา-ตราดแถวๆ วัดศรีเอี่ยม และมีสถานีให้บริการ คือ สถานีศรีเอี่ยม ทำให้คนที่ซื้อบ้านเดี่ยว ทาวน์โฮม บ้านมือสองบางนา-ตราดสามารถเดินทางไปยังโซนรามคำแหง บางกะปิ ลาดพร้าวได้อย่างง่ายดาย
											</p>
											<p>
												สำหรับใครที่ซื้อบ้านมือสองบางนา-ตราดแล้วต้องเดินทางไปต่างจังหวัดหรือต่างประเทศบ่อย ในอนาคตจะมีรถไฟฟ้าบางนา-ท่าอากาศยานสุวรรณภูมิ โดยมีจุดเริ่มต้นที่บริเวณสี่แยกบางนา แถมยังมีสกายวอร์กเชื่อมถึงสถานี BTS บางนาอีกด้วย
											</p>

											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์
											</h3>
											<p>
												ถนนเทพรัตน์ หรือที่เรารู้จักกันในชื่อ ถนนบางนา-ตราด เป็นถนนที่เชื่อมต่อกับถนนหลักหลากหลายเส้นทาง ไม่ว่าจะเป็นถนนวงแหวนกาญจนาภิเษก ทางพิเศษบูรพาวิถี ถนนมอเตอร์เวย์ ถนนสุขุมวิท ถนนศรีวารีน้อย (บางนา-ตราด กม.18) แถมยังมีทางด่วนพิเศษบูรพาวิถี (ทางด่วนบางนา-บางปะกง) เป็นทางยกระดับอยู่ด้านบน โดยมีถนนมอเตอร์เวย์(กรุงเทพฯ-ชลบุรี) เป็นทางคู่ขนานด้านทิศเหนือใช้วิ่งออกนอกเมืองได้ และบริเวณหัวถนนยังเชื่อมต่อกับทางด่วนขั้นที่ 1 (บางนา-ดาวคะนอง) และทางด่วนรามอินทรา-อาจณรงค์ในการวิ่งเข้าโซนอื่นๆ ของกรุงเทพมหานครได้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ใครที่ซื้อบ้านมือสองบางนา-ตราด ไม่ต้องกลัวอด เพราะย่านนี้เต็มไปด้วยแหล่งชอป ชิม ชิลล์ ครบ ทั้งห้างสรรพสินค้าอย่างเซ็นทรัล บางนา, บิ๊กซี บางนา, เทสโก้โลตัส บางนา, เมกา บางนา หรืออย่างห้างที่เพิ่งเปิดได้ไม่นาน อย่าง เซ็นทรัล วิลเลจ luxury outlet บนเนื้อที่ 100 ไร่ ใกล้กับสนามบินสุวรรณภูมิ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												แต่สำหรับใครที่ชอบการซื้อของตกแต่ง บ้านมือสองบางนา-ตราดเรียกได้ว่าเป็นแหล่งซื้อขายเฟอร์นิเจอร์ชื่อดังเหมาะสำหรับคนที่เพิ่งซื้อบ้านแล้วอยากลงมือตกแต่งด้วยตัวเอง ไม่ว่าจะเป็น เอสบี ดีไซน์สแควร์, อินเด็กซ์ ลิฟวิ่งมอลล์, ชิค รีพับบลิค, อิเกีย บางนา หรือถ้าอยากรีโนเวทบ้านก็มีไทวัสดุก่อสร้างให้เลือกซื้อของสำหรับตกแต่งและรีโนเวทบ้านได้ด้วย
											</p>
											<p>
												ส่วนสิ่งอำนวยความสะดวกด้านกาารใช้ชีวิตตอื่นๆ อย่างโรงเรียนและสถานพยาบาลก็ล้วนแต่มีชื่อเสียง เช่น เช่น รพ.ไทยนครินทร์, รพ.ศิครินทร์, รพ.พริ้นซ์ ฮอสพิทอล สุวรรณภูมิ และสถานศึกษา เช่น โรงเรียนนานาชาติเบิร์คลีย์, โรงเรียนนานาชาติคอนคอร์เดียน, โรงเรียนบางกอกพัฒนา, โรงเรียนราชวินิตบางแก้ว,มหาวิทยาลัยอัสสัมชัญ, มหาวิทยาลัยหัวเฉียว อีกทั้งยังเดินทางไปยังสุวรรณภูมิได้อย่างสะดวก บ้านมือสองบางนา-ตราดจึงเหมาะสำหรับคนทำงานในสนามบินอีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านบางนา-ตราด
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ถ้าใครมองหาทำเลที่เติบโตและมีการลงทุนแบบต่อเนื่อง บ้านมือสองบางนา-ตราดดูได้จากการพัฒนาศูนย์การค้าใหญ่ๆ ในทำเล เช่น Bangkok Mall ตั้งอยู่บริเวณหัวมุมสี่แยกบางนา ตรงข้ามกับศูนย์แสดงสินค้าไบเทค บนเนื้อที่กว่า 100 ไร่ โดยอนาคตจะกลายเป็นศูนย์การค้าและออฟฟิศแบบครบวงจร, เมกาซิตี้ ก็เป็นอีกหนึ่ง Mixed-Use ครบครันไปด้วย โรงแรม อาคารสำนักงาน ที่พักอาศัย ส่วนต่อขยายของศูนย์การค้าและอื่นๆ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ด้วยศักยภาพของทำเลดังกล่าว ส่งผลให้บ้บ้านมือสองบางนา-ตราดไม่ว่าจะเป็นบ้านเดี่ยว ทาวน์โฮม โครงการหมู่บ้านต่างๆ เป็นที่ต้องการสำหรับทั้งผู้ซื้ออยู่อาศัยเองและนักลงทุน โดยมีตั้งแต่ระดับราคาตั้งแต่ 3–10 ล้านบาทขึ้นไป ซึ่งรองรับความต้องการซื้อที่อยู่อาศัยทั้งคนที่ทำงานอยู่ในแถบกรุงเทพฯ ชั้นใน คนทำงานในกลุ่มโรงงานย่านสมุทรปราการ ซึ่งกลุ่มที่กำลังซื้อสูงและเช่าสูงอีกด้วย
											</p>
											<p>
												ยกตัวอย่างโครงการบ้านเดี่ยว ทาวน์โฮม บ้านมือสองบางนา-ตราด เช่น หมู่บ้านอณาสิริบางนา, หมู่บ้านสิรินเฮ้าส์บางนา, หมู่บ้านศุภาลัยบางนา, หมู่บ้านเศรษฐสิริบางนา, หมู่บ้านพลีโน่สุขุมวิทบางนา, หมู่บ้านพฤกษาบางนา, หมู่บ้านบุราสิริบางนา เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'phraeksa'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้าน แพรกษา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โซนแพรกษานับเป็นย่านรองรับการขยายตัวของเมืองในด้านที่อยู่อาศัยของทั้งจากฝั่งสมุทรปราการและแหล่งงานขนาดใหญ่อย่างนิคมอุตสาหกรรมเช่นเดียวกันกับโซนบางนา-ตราดและเทพารักษ์ ทำให้มีโครงการบ้านจัดสรรเกิดขึ้นมากมาย ไม่ว่าจะเป็นหมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม รวมทั้งอพาร์ตเมนต์ หอพักก็ล้วนเปิดให้ทั้งซื้อและเช่ากันคึกคัก เพราะสิ่งอำนวยความสะดวกต่างๆ ทั้งรถไฟฟ้า ถนน และศักยภาพทำเลเริ่มมีให้เห็นอย่างต่อเนื่อง และมีแนวโน้มที่จะพัฒนาจนกลายเป็น Hub ที่อยู่อาศัยใหม่ของคนทำงานทั้งในจังหวัดสมุทรปราการและจังหวัดใกล้เคียง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านแพรกษา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									สิ่งหนึ่งที่เป็นปัจจัยทำให้คนอยากซื้อบ้านในโซนแพรกษามากขึ้นนั่นก็คือ การเข้าถึงของรถไฟฟ้า โดยในปัจจุบันมีรถไฟฟ้าสายสีเขียวส่วนต่อขยายจากสถานี BTS แบริ่งมาจนถึงสถานีเคหะฯ เข้ามาเพิ่มศักยภาพให้กับพื้นที่ต่างๆ ในโซนจังหวัดสมุทรปราการ รวมถึงบริเวณถนนแพรกษาให้มีความคึกคักและเดินทางได้สะดวกมากขึ้นแล้ว ยังมีโครงการระบบขนส่งมวลชน และเส้นทางคมนาคมอื่นๆ อีกที่เมื่อสร้างเสร็จจะช่วยเสริมศักยภาพให้กับพื้นที่นี้สูงขึ้นไปอีกในอนาคต เช่น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>
													<b>รถไฟฟ้าสายสีเหลือง (ลาดพร้าว-สำโรง)</b> สายรถไฟฟ้าใหม่ที่จะเข้ามาช่วยลดปัญหาการจราจรติดขัด บนถนนลาดพร้าว ถนนศรีนครินทร์ และถนนเทพารักษ์ที่มีมาอย่างยาวนานให้เดินทางได้สะดวกมากยิ่งขึ้น
												</li>
												<li>
													<b>รถไฟฟ้าโมโนเรล สายบางปู–สุวรรณภูมิ</b> โดยสถานีแพรกษาจะเป็นจุดสำคัญ เนื่องจากจะเชื่อมต่อการเดินทางกับรถไฟฟ้าสายสีเขียว (แบริ่ง-สมุทรปราการ) ด้วย
												</li>
												<li>
													<b>ไฮสปีดเทรน กรุงเทพฯ-ระยอง</b> อีกหนึ่งเส้นทางรถไฟสายใหม่ที่อยู่ไม่ไกลจากย่านแพรกษา โดยจะเน้นเชื่อมต่อสนามบินดอนเมือง สุวรรณภูมิ และอู่ตะเภาเข้าไว้ด้วยกัน
												</li>
											</ul>

											<h3 class="mt-3">
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ถนนแพรกษาที่เป็นถนนสายรองซึ่งแยกออกมาจากถนนสุขุมวิท และสามารถเชื่อมต่อกับถนนเทพารักษ์ได้อีกเส้นทางหนึ่ง เพื่อเดินทางไปยังเส้นบางนา-ตราด หรือเดินทางไปยังศรีนครินทร์ออกไปยังย่านบางกะปิก็ได้ โดยการวิ่งคู่ขนานกับสุขุมวิทไปตัดเข้าถนนพัฒนาการ ช่วงเพชรบุรี-พระรามเก้าได้เลย หรือถ้าใครต้องการเข้าไปยังโซนสุขุมวิทก็สามารถวิ่งไปทางสามแยกแพรกษาจากนั้นใช้เส้นสุขุมวิทขับตามแนว BTS เข้าเมืองได้เลย หรือจะใช้ทางด่วนกาญจนาภิเษกก็สะดวกไม่แพ้กัน
											</p>
											<p>
												ในฝั่งออกนอกเมืองสามารถวิ่งไปยังถนนกิ่งแก้ว แล้วไปยังสนามบินสุวรรณภูมิได้ หรือจะใช้ทางด่วนวิ่งตรงไปยังจังหวัดชลบุรี เพื่อทำธุระหรือพักผ่อนก็ได้ โดยใช้ระยะเวลาไม่นาน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับใครที่ซื้อบ้านอยู่ในทำเลแพรกษา รับรองได้ว่า เต็มอิ่มกับการใช้ชีวิต เพราะที่นี่มีสิ่งอำนวยความสะดวกสำหรับการใช้ชีวิตประจำวันค่อนข้างมากทั้งตลาดสด ร้านสะดวกซื้อ หรือว่าห้างสรรพสินค้าโรบินสันที่อยู่บนถนนสุขุมวิทห่างจากปากทางถนนแพรกษาไม่ไกล และไฮเปอร์มาร์เก็ต เช่น บิ๊กซี ที่อยู่เยื้องๆ กับโรบินสัน หรือถ้าจะเดินทางไปเที่ยวห้างสรรพสินค้าใหญ่ๆ อย่างเมกา บางนา ก็สามารถใช้เส้นทางลัดเลาะซอยต่างๆ ไปได้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ส่วนโรงเรียนและโรงพยาบาลนั้นมีกระจายตัวอยู่หลากหลายโซนในจังหวัดสมุทรปราการ ซึ่งก็เดินทางจากถนนแพรกษาไปได้ง่ายๆ เช่นกัน ไม่ว่าจะเป็น…
											</p>
											<ul>
												<li>
													โรงพยาบาล : โดยบริเวณสำโรงจะมีโรงพยาบาลสำโรงการแพทย์ บริเวณถนนศรีนครินทร์มีโรงพยาบาลเปาโลสมุทรปราการ และโรงพยาบาลศิครินทร์ ส่วนในถนนลาซาลออกมาเส้นบางนา-ตราด ก็จะมีโรงพยาบาลไทยนครินทร์ โรงพยาบาลปิยะมินทร์ และโรงพยาบาลจุฬารัตน์ สามารถเลือกใช้บริการได้ตามความสะดวก
												</li>
												<li>
													โรงเรียน : หากเป็นโรงเรียนที่ตั้งอยู่บริเวณถนนแพรกษาก็จะมีโรงเรียนสารวิเทศน์สมุทรปราการ หรือถ้าเข้าไปในเส้นหนามแดง-บางพลีก็มี โรงเรียนสิงคโปร์ International school สุวรรณภูมิ ซึ่งเป็นโรงเรียนนานาชาติที่อยู่ใกล้ๆ สามารถพาบุตรหลานไปเรียนได้อย่างสะดวก
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านแพรกษา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ทำเลย่านแพรกษา เป็นอีกทำเลหนึ่งในสมุทรปราการที่มีโครงการที่อยู่อาศัยประเภทบ้านจัดสรรเกิดขึ้นมากมายในช่วงหลายปีที่ผ่านมา นอกจากนี้ยังมีโครงการของการเคหะแห่งชาติอย่างโครงการบ้านเอื้ออาทร แพรกษาอยู่ด้วย ซึ่งแสดงให้เห็นว่า ทำเลบนถนนแพรกษาเป็นทำเลยอดฮิตของโครงการที่อยู่อาศัยทั้งหมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												โดยที่ทาวน์เฮ้าส์ราคาประมาณ 1-2 ล้านบาท เป็นที่อยู่อาศัยที่มีมากที่สุด และขายได้ดีที่สุดในย่านนี้ ส่วนราคาบ้านเดี่ยวก็จะมีหลายราคาขึ้นอยู่กับทำเลโดยด้านฝั่งถนนแพรกษาตอนล่าง ราคาที่อยู่อาศัยจะอยู่ที่ประมาณ 2 - 5 ล้านบาท แต่หากเป็นด้านฝั่งถนนแพรกษาตอนบน จะมีระดับราคาหลากหลายมากกว่า ตั้งแต่ 2 – 10 ล้านบาทขึ้นไป ยกตัวอย่างโครงการบ้านในโซนนี้ เช่น บ้านเดอะทรัสต์แพรกษา, หมู่บ้านอินดี้แพรกษา, หมู่บ้านแพรกษาเมืองใหม่, บ้านปัญฐิญาแพรกษา, หมู่บ้านเจทาวน์แพรกษา เป็นต้น
											</p>
											<p>
												ส่วนสาเหตุที่ทำให้ทำเลแพรกษามีการสร้างโครงการที่อยู่อาศัยมากมาย เป็นเพราะในพื้นที่เป็นที่ตั้งของโรงงานอุตสาหกรรม หรือว่านิคมอุตสาหกรรมบางปู มีสิ่งอำนวยความสะดวกค่อนข้างครบ อีกทั้งมีการเดินทางในถนนแพรกษาก็ค่อนข้างสะดวกทั้งจากรถโดยสารรับจ้าง รถยนต์ส่วนบุคคล และในอนาคตจะมีรถไฟฟ้าที่เชื่อมต่อกันอีกหลายสาย ทำให้ถนนแพรกษาเป็นอีกทำเลสำหรับโครงการที่อยู่อาศัยในอนาคตที่คาดว่าจะมีการขยายตัวค่อนข้างมากอย่างแน่นอน จึงเหมาะสำหรับคนที่มองหาบ้านในย่านชานเมืองในราคาย่อมเยา แทนการเช่าอพาร์ตเมนต์หรือคอนโดในตัวเมืองชั้นใน ซึ่งมีราคาสูงกว่าหรืออาจจะเทียบเท่ากับราคาผ่อนเมื่อทำการซื้อบ้านในย่านนี้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bearing'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านแบริ่ง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									การจะซื้อบ้านในย่านแบริ่ง หรือซอยสุขุมวิท 107 เท่ากับการลงทุนซื้ออนาคตทำเลย่านสุขุมวิทตอนปลาย ซึ่งในปัจจุบันถูกยกให้เป็นเขตเศรษฐกิจ (East Business District : EBD) เนื่องจากเป็นทำเลที่มีครบทั้งแหล่งไลฟ์สไตล์ การพัฒนาที่ดิน การคมนาคมที่สะดวก
								</p>
								<p>
									อีกทั้งเป็นทำเล City Trend ที่กระจายตัวและขยายออกจากศูนย์กลางย่านธุรกิจของสุขุมวิทตอนต้น-กลาง เข้ามาสู่สุขุมวิทตอนปลาย ไม่ว่าจะเป็น Office Building ใหม่และห้างสรรพสินค้าขนาดใหญ่ จึงทำให้ทำเลนี้ดึงดูดให้คนทำงานทั้งชาวไทยและชาวต่างชาติโดยเฉพาะคนจีนและเกาหลีที่ทำงานอยู่ในโรงงานย่านสมุทรปราการ อยากจะลงทุนซื้อที่อยู่อาศัยในย่านนี้ไว้สำหรับเก็งกำไร รวมถึงซื้อเพื่ออยู่อาศัยในระยะยาวด้วยเช่นเดียวกัน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านแบริ่ง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									รถไฟฟ้านับเป็นปัจจัยแรกๆ ที่ทำให้แบริ่งกลายเป็นทำเลศักยภาพ เริ่มต้นตั้งแต่การมาเยือนของรถไฟฟ้า BTS สายสีเขียว (สายสุขุมวิท ช่วงอ่อนนุช-แบริ่ง) และการสร้างรรถไฟฟ้าส่วนต่อขยายจากแบริ่งไปสู่สถานีเคหะฯ และในอนาคตมีแผนที่สร้างต่อไปจนถึงย่านบางปู ทำให้ย่านนี้คึกคักและกลายเป็นจุดกึ่งกลางระหว่างความเป็นเมืองของกรุงเทพฯ ซึ่งเดินทางเชื่อมต่อกับบริเวณชานเมืองได้อย่างง่ายดาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												และถ้าหากใครซื้อบ้าน คอนโดที่ซอยแบริ่ง (สุขุมวิท 107) การเดินทางด้วยรถไฟฟ้าถือว่าค่อนข้างสะดวก เพราะตัวสถานี BTS แบริ่งนั้นอยู่ห่างจากปากซอยไปเพียง 300 เมตรเท่านั้น และใช้ระยะเวลาในการเดินทางไปยังใจกลางเมืองอย่างสถานีอโศกประมาณ 20 นาที จึงเหมาะสำหรับคนที่ทำงานอยู่ในย่าน CBD ที่ต้องการซื้อบ้านหรือคอนโดในราคาที่เอื้อมถึง แต่ก็ไม่ไกลจากแหล่งงานด้วย
											</p>
											<p>
												ส่วนใครที่ทำงานอยู่ฝั่งลาดพร้าว รามคำแหง แต่อยากจะมาซื้อบ้านในซอยแบริ่ง ในอนาคตซอยนี้จะอยู่ไม่ไกลจาก MRT สายสีเหลือง ซึ่งเป็นรถไฟฟ้าที่วิ่งผ่านช่วงลาดพร้าว บางกะปิ รามคำแหง สำโรง ทำให้การเดินทางจากโซนฝั่งตะวันออกของกรุงเทพ ไปยังกรุงเทพฯ เขตชั้นกลางได้ง่ายดายขึ้น
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ย่านแบริ่งมีถนนเส้นสำคัญตัดผ่านหลายสายเริ่มจากถนนแบริ่ง (ซอยสุขุมวิท 107) จะเป็นถนนเส้นรองที่เชื่อมต่อระหว่างถนนสุขุมวิทเข้ากับถนนศรีนครินทร์ โดยตลอดทั้งเส้นจะมีซอยย่อยที่เป็นที่ตั้งของบ้านและคอนโดอยู่เป็นจำนวนมาก และยังสามารถลัดเลาะไปยังซอยลาซาลได้
											</p>
											<p>
												นอกจากนี้ยังมีทางพิเศษอย่างทางพิเศษฉลองรัช ซึ่งยาวไปจนถึงทางพิเศษบูรพาวิถีที่เชื่อมต่อไปลงยังโซนบางนาหรือจะใช้วิ่งต่อไปยังจังหวัดชลบุรีได้ โดยมีจุดขึ้นลงที่ใกล้ที่สุดอยู่ตรงสี่แยกบางนา ซึ่งเดินทางจากซอยแบริ่งได้ง่าย เพราะห่างกันเพียง 1 สถานีรถไฟฟ้าเท่านั้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									จุดเด่นของการซื้อบ้านในซอยแบริ่งอีกอย่างหนึ่งก็คือ ความสะดวกสบายในการจับจ่ายใช้สอยและการใช้ชีวิต โดยรอบทำเลมี Community Mall มากมาย เช่น JAS URBAN Srinakarin, ฟู้ดแลนด์ ศรีนครินทร์, อิมพีเรียลเวิลด์ สำโรง, เซ็นทรัลบางนา อยู่ใกล้ศูนย์เเสดงสินค้าเเละการประชุมนานาชาติกรุงเทพ (ไบเทค) ซึ่งเป็นแหล่งแสดงสินค้าและจัดงานระดับประเทศอยู่เป็นประจำ นอกจากนี้ก็จะมีตลาดเอี่ยมเจริญ และตลาดใหม่สำโรงอยู่ไม่ไกล ส่วนสตรีทฟู้ดภายในซอยแบริ่งก็เรียกได้ว่า มีให้เห็นตลอดทั้งเส้น ไม่ต้องกลัวว่าจะอดเลยแม้แต่น้อย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ส่วนสถานศีกษาจะมีทั้งโรงเรียนนานาชาติ เอกชน และรัฐบาล เช่น โรงเรียนนานาชาติเซนต์แอนดรูวส์ สุขุมวิท 107, โรงเรียนทรงวิทยา, โรงเรียนอนุบาลนนนที, โรงเรียนเซนต์โยเซฟ บางนา ด้านโรงพยาบาลก็มีกระจายตัวอยู่รอบๆ โซนแบริ่งหลายแห่ง เช่น โรงพยาบาลมนารมย์, โรงพยาบาลสำโรงการแพทย์ เป็นต้น
											</p>
											<p>
												ด้วยสิ่งอำนวยความสะดวกเหล่านี้ทำให้ทำเลแบริ่งพร้อมรองรับผู้คนทุกเพศทุกวัย ไม่ว่าจะเป็นวัยเด็ก วัยเรียน วัยทำงาน หรือผู้สูงอายุ ก็สามารถใช้พื้นที่ในทำเลแห่งนี้ได้อย่างเต็มที่ อีกทั้งยังมีสิ่งอำนวยความสะดวกต่างๆ ที่ครบครัน แบบเรียกได้ว่าไม่จำเป็นต้องออกไปหาที่ไหนไกลเลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านแบริ่ง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									จากศักยภาพของทำเลโดยรวมทำให้ที่ดินของซอยแบริ่งมีแนวโย้มที่พุ่งสูงขึ้นในทุกๆ ปีอย่างน้อย 7-10% โดยในปี 2555-2560 ทำเลแบริ่งเป็นทำเลที่ได้รับความนิยมอย่างต่อเนื่องจากอัตราการขายที่สูงกว่าร้อยละ 70 ตลอดระยะเวลา 5 ปีเลยทีเดียว แน่นอนว่าใครที่ต้องการซื้อบ้านเดี่ยว บ้านมือสอง หรือคอนโดในย่านนี้ก็ต้องรีบทำการสำรวจหาที่อยู่อาศัยที่ถูกใจก่อนเพื่อจับจองไว้รอรับการพัฒนาที่จะเพิ่มขึ้นได้ในอนาคต ซึ่งในปัจจุบันทำเลนี้ราคาคอนโดยังถือว่าไม่สูงมาก ยังมีคอนโดที่ราคาไม่เกิน 2 ล้านรอให้จับจองอยู่บ้างเช่นกัน
								</p>
								<p>
									ยกตัวอย่างโครงการบ้านในซอยแบริ่ง เช่น บ้านเช่ากัญญาเฮ้าส์แบริ่ง, เดอะคอนเนคแบริ่ง, หมู่บ้านศุภาลัยวิลล์แบริ่ง58 ส่วนโครงการคอนโดในซอยแบริ่งมีให้เลือกมากมายหลายโครงการ เช่น ไนท์บริดจ์แบริ่ง, Ideo แบริ่ง, LPN สุขุมวิท 76, Deco condo แบริ่ง, Attitude แบริ่ง, Kensington แบริ่ง เป็นต้น
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bangpu'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้าน บางปู
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									หากพูดถึงบางปู บางคนอาจจะนึกถึงสถานที่ท่องเที่ยวเชิงธรรมชาติอย่างสถานตากอากาศบางปู หรืออาจจะนึกถึงความเป็นแหล่งงานเพราะเป็นพื้นที่ตั้งของนิคมอุตสาหกรรมบางปู ซึ่งตั้งอยู่ในทำเลนี้กว่า 40 ปีแล้ว แต่หลังจากที่มีข่าวคราวว่าจะทำการพัฒนารถไฟฟ้าให้เข้าถึงทำเลนี้มากขึ้น ความเจริญย่อมเข้ามา ทำให้ทำเลบางปูกลายเป็นแหล่งที่อยู่อาศัยสำหรับคนที่อยากใช้ชีวิตในแถบชานเมือง ใกล้แหล่งพักผ่อน และอยู่ไม่ห่างจากแหล่งงานในพื้นที่ อีกทั้งสามารถเดินทางไปยังสนามบินสุวรรณภูมิได้โดยง่าย โดยที่ราคาบ้านหรือคอนโดไม่สูง แม้จะเป็นกลุ่ม First Jobber ก็สามารถเป็นเจ้าของได้เช่นเดียวกัน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านบางปู
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									มาดูสิ่งแรกที่ช่วยกระตุ้นให้หลายๆ คนอยากเป็นเจ้าของบ้านในย่านบางปู นั่นคือ การมาถึงของรถไฟฟ้าสายสีเขียวส่วนต่อขยาย หรือ BTS สายสำโรง-บางปู โดยจะกินพื้นที่ทั้งหมด 5 สถานี ได้แก่ สถานีสวางคนิวาส (ช่วงซอยเทศบาลบางปู 59 ใกล้กับสวางคนิวาส ศูนย์เวชศาสตร์ฟื้นฟู สภากาชาดไทย) สถานีเมืองโบราณ(ซอยเทศบาลบางปู 65 เมืองโบราณ) สถานีศรีจันทร์ประดิษฐ์ (ซอยเทศบาลบางปู 96 ทางเข้าวัดศรีจันทร์ประดิษฐ์)  สถานีบางปู (ซอยเทศบาลบางปู 77 ทางเข้าสถานตากอากาศบางปูและนิคมอุตสาหกรรมบางปู) และสถานีตำหรุ (ซอยเทศบาลบางปู 108 ก่อนถึงแยกถนนตำหรุ-บางพลี ประมาณ 500 เมตร)
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												แน่นอนว่า การที่มีสถานีรถไฟฟ้าในทำเลก็เป็นผลดีสำหรับคนที่ซื้อบ้านอยู่ในทำเลเหล่านี้ เพราะสามารถเดินทางเข้าเมืองอย่างแถบอโศก-ทองหล่อ หรือจะไปเปลี่ยนเพื่อขึ้น MRT เพื่อไปเส้นพระราม 9 บางซื่อ ไปจนถึงฝั่งธนบุรีได้ง่ายมากยิ่งขึ้น แถมในอนาคตก็จะมีรถไฟฟ้าสายสีเหลือง (ลาดพร้าว-สำโรง) ที่จะมีสถานี Interchange อยู่ที่ BTS สำโรง ทำให้คนที่อยู่อาศัยย่านบางปูสามารถเดินทางไปยังย่านลาดพร้าว บางกะปิ รัชดาภิเษกได้เร็วมากขึ้นด้วย
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												คนที่ซื้อบ้านในย่านบางปูส่วนใหญ่ใช้รถส่วนตัวในการเดินทางเป็นหลัก โดยสามารถใช้ถนนสาย 1006 ผ่านนิคมอุตสาหกรรมบางพลี ไปออกถนนบางนา-ตราด หรือขึ้นทางด่วนบูรพาวิถี เพื่อเข้าออกเมืองได้ หรือจะใช้ถนนเลียบคลองส่งน้ำสุวรรณภูมิ ก็สามารถไปออกยังถนนบางนา-ตราด ก็ได้เช่นกัน นอกจากนี้ยังสามารถใช้เส้นบางนา-ตราดเพื่อมุ่งตรงสู่ย่านธุรกิจใหม่ของกรุงเทพฝั่งตะวันออก ซึ่งเชื่อมต่อระหว่าง สุขุมวิท-ฉะเชิงเทรา-ชลบุรีได้อย่างรวดเร็ว
											</p>
											<p class="mb-0">
												ส่วนทางฝั่งสุวรรณภูมิก็ใช้ถนนตำหรุ-บางพลี และถนนกิ่งแก้ว ไปสุวรรณภูมิได้สะดวก และวงแหวนกาญจนาภิเษกก็สามารถใช้ข้ามฝั่งไป สุขสวัสดิ์, บางขุนเทียน, พระราม 2, บางแค, บางใหญ่ หรืออีกฝั่งจะไปโซนมีนบุรี, คลองสามวา, ปทุมธานี, รังสิต ยาวไปอยุธยาได้ง่ายๆ
											</p>
											<p>
												หรือถ้าใครต้องเดินทางไปแถบเพชรบุรี-พระราม 9 ก็สามารถวิ่งออกเส้นศรีนครินทร์ ขึ้นไปทางประเวศถึงเส้นรามคำแหง ตัดเข้าพัฒนาการ เพชรบุรี และพระราม 9 ได้เลย หรือถ้าจะไปเส้นสุขุมวิทก็แค่ใช้ถนนเทพารักษ์ลัดเข้าเส้นสุขุมวิทตรงแยกเทพารักษ์แล้วตามแนวรถไฟฟ้าไปเรื่อยๆ ก็สะดวกเช่นกัน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									หากมีเวลาในวันหยุดพักผ่อนสามารถใช้ทางด่วนวงแหวนตะวันออก (อยู่บนถนนเทพารักษ์) วิ่งไปลงบางนา ก็มีห้าง Mega Bangna และ IKEA ที่เต็มไปด้วยร้านค้ามากมายให้ได้เดินเล่นกันได้ แต่ถ้าต้องการพักผ่อนในเชิงธรรมชาติก็มีสถานตากอากาศบางปูอยู่ใกล้ๆ หรือจะวิ่งไปบางกระเจ้าก็ไม่ไกลอย่างที่คิด
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ส่วนในวันหยุดที่ไม่อยากไปไหนใกล้โซนนี้ก็มีแหล่งซื้ออาหารให้จับจ่ายใช้สอยอยู่มากมาย ทั้งตลาดตำหรุ Tesco Lotus บางปู, Sino Park, Robinson สมุทรปราการ หรือจะสตรีทฟู้ด คาเฟ่ ก็มีให้ครบเพราะอยู่ใกล้แหล่งท่องเที่ยวขึ้นชื่อ และรายล้อมด้วยแหล่งงานที่ทำให้ย่านนี้กลายเป็นย่านชุมชนที่มีคนอยู่อาศัยเป็นจำนวนมาก และคึกคักอยู่ตลอดทั้งวัน
											</p>
											<p>
												ในด้านสถานพยาบาลและโรงเรียนก็ไม่ต้องไปไหนไกลมีให้เลือกหลากหลาย เช่น โรงเรียนนวมินทราชินูทิศ สวนกุหลาบวิทยาลัย สมุทรปราการ, มหาวิทยาลัยราชภัฎธนบุรี สมุทรปราการ, โรงเรียน.มัธยมวัดศรีจันทร์ประดิษฐ์ ส่วนโรงพยาบาลในทำเลก็จะมี โรงพยาบาลรามาธิบดีจักรีนฤบดินทร์ สมุทรปราการ, โรงพยาบาลศิครินทร์ สมุทรปราการ, โรงพยาบาลบางพลี จึงไม่ต้องกังวลเรื่องสุขภาพและการเรียนของบุตรหลานเลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านบางปู
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ด้านศักยภาพทำเลรอบบางปูดังที่กล่าวมาน่าจะช่วยสนับสนุนให้การใช้ชีวิตในย่านชานเมืองของคนที่ต้องการซื้อบ้านเดี่ยว บ้านมือสอง หรือคอนโดในแถบบางปูสามารถใช้ชีวิตได้อย่างสะดวกสบายมากขึ้น หรือถ้าใครสนใจปล่อยเช่า ทำเลนี้ถือว่าลงทุนไม่แพง และมีตลาดคนเช่ารองรับแบบเห็นได้ชัดนั่นคือ คนที่ทำงานในโซนเขตอุตสาหกรรม ซึ่งโครงการบ้านที่น่าสนใจในย่านนี้สำหรับการลงทุนซื้อหรือปล่อยเช่ามีด้วยกันหลายโครงการ เช่น หมู่บ้านพฤกษาบางปู, บ้านพฤกษา 15 นิคมบางปู, พฤกษา 28 บางปู, หมู่บ้านพฤกษา 143 สุขุมวิท-บางปู, หมู่บ้านสิวารมณ์บางปู เป็นต้น
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'phra-pradaeng'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้าน พระประแดง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									แต่เดิมย่านพระประแดงเป็นทำเลเก่าแก่ที่มีชุมชนอยู่อาศัยมานาน จึงทำให้กลายเป็นทำเลที่พักอาศัยของคนในชุมชนดั้งเดิมและเป็นแหล่งอุตสาหกรรมอีกแห่งหนึ่งในแถบชานเมือง แต่เมื่อเริ่มมีความเจริญเข้ามาทั้งห้างสรรพสินค้า ถนน ร้านรวง ไปจนถึงรถไฟฟ้าก็ทำให้ทำเลพระประแดงดูคึกคักมากขึ้น เรียกได้ว่า ลบภาพในอดีตของย่านนี้ที่ดูเป็นเพียงแหล่งโรงงานอุตสาหกรรมและดูเหมือนไกลเมืองไปได้เลย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านพระประแดง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									สำหรับรถไฟฟ้าที่จะเข้ามาทำให้ทำเลพระประแดงมีศักยภาพและเจริญมากขึ้นคือ รถไฟฟ้าสายสีม่วงส่วนต่อขยาย ช่วงเตาปูน – ราษฎร์บูรณะ มีสถานีทั้งสิ้น 17 สถานี เป็นใต้ดิน 10 สถานี และทางยกระดับ 7 สถานี แต่จะมีสถานีรถไฟฟ้าทั้งหมด 6 สถานีที่จะอยู่ในย่านพระประแดงหรือพื้นที่ใกล้เคียง ได้แก่
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>สถานีดาวคะนอง ถนนสุขสวัสดิ์ ระหว่างซอย 12 และ 14</li>
												<li>สถานีบางปะกอก ถนนสุขสวัสดิ์ซอย ระหว่างซอย 23 และ 25</li>
												<li>สถานีประชาอุทิศ ถนนสุขสวัสดิ์ 44</li>
												<li>สถานีราษฎร์บูรณะ บริเวณกลางถนนสุขสวัสดิ์ คร่อมคลองแจงร้อน เชื่อมต่อกับอาคารจอดรถ</li>
												<li>สถานีพระประแดง บริเวณกลางถนนสุขสวัสดิ์ ใกล้กับถนนวงแหวนอุตสาหกรรม สามแยกพระประแดง</li>
												<li>สถานีครุใน บริเวณกลางถนนสุขสวัสดิ์ตรงปากซอยสุขสวัสดิ์ 70</li>
											</ul>
											<p>
												ซึ่งการมาของรถไฟฟ้าทำให้บริเวณโดยรอบของสถานีเหล่านี้เป็นที่ตั้งของที่อยู่อาศัยใหม่ ซึ่งมีทั้งโครงการบ้านเดี่ยว บ้านมือสองในหลายระดับราคา ขึ้นอยู่กับที่ตั้งแต่ความห่างไกลจากสถานีรถไฟฟ้า ยกตัวอย่าง เช่น บ้านกลางเมืองสุขสวัสดิ์, หมู่บ้านศุภาลัย การ์เด้นวิลล์ ประชาอุทิศ-สุขสวัสดิ์, บ้านเดี่ยว The City สาทร-สุขสวัสดิ์, วิลลาจจิโอ สุขสวัสดิ์-ประชาอุทิศ เป็นต้น
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p>
												ด้านการเดินทางด้วยรถส่วนตัวในย่านพระประแดงสามารถใช้ถนนเชื่อมเพื่อเข้าออกเมืองได้หลายเส้นทาง เช่น ถนนประชาอุทิศ ถนนราษฎร์บูรณะ ถนนพุทธบูชา ถนนพระราม 2 และถนนพระราม 3 หรือจะใช้สะพานวงแหวนอุตสาหกรรมทั้งสะพานภูมิพล 1 และสะพานภูมิพล 2 ในการข้ามไปฝั่งพระราม 3 พระประแดง ปู่เจ้าสมิงพราย จังหวัดสมุทรปราการ หรือไปโซนบางนาก็สะดวก อีกทั้งยังสามารถเชื่อมต่อไปยังพื้นที่ CBD ของกรุงเทพฯ อย่างสาทร-สีลมได้อย่างสะดวกและง่ายด้วยทางด่วนเฉลิมมหานคร ทางพิเศษกาญจนาภิเษก (บางพลี – สุขสวัสดิ์) และทางด่วนสะพานวงแหวนอุตสาหกรรม (สะพานข้ามแม่น้ำเจ้าพระยา)
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ไม่ใช่แค่เรื่องของการเดินทางที่สะดวกสบายเท่านั้น ทำเลย่านพระประแดงนี้ยังมีองค์ประกอบในการอยู่อาศัยที่ครบ ไม่ว่าจะเป็นใกล้สถานศึกษา ใกล้โรงพยาบาล ใกล้ศูนย์การค้าชั้นนำ เช่น เซ็นทรัลพระราม2, เซ็นทรัล พระราม 3 ,บิ๊กซี , Lotus, The Bright , SB Design Square, โฮมโปร, Forest และตลาดสุขสวัสดิ์ 39 เป็นต้นรวมถึงยังเป็นการอยู่อาศัยที่ผสมผสานกับชุมชนดั้งเดิม ทำให้ร้านค้า คาเฟ่ในย่านนี้ยังคงอนุรักษ์ความเป็นธรรมชาติ เน้นสไตล์การพักผ่อนแนวชุมชนเก่าในแบบที่ลงตัว
								</p>
								<p>
									นอกจากนี้ยังเป็นทำเลที่อยู่ไม่ไกลจากแหล่งงานอย่างโรงงานอุตสาหกรรมขนาดใหญ่ (พระประแดง-สำโรง) และ ออฟฟิศต่างๆ ในเขตพระรามสาม-สีลม-สาทร อีกทั้งยังมีสถานศึกษาที่สำคัญ เช่น มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี (มจธ.) ซึ่งเดินทางไปได้สะดวก ส่วนด้านบริการสาธารณะอย่างโรงพยาบาลก็มีให้ครบครัน เช่น โรงพยาบาลบางปะกอก 3, โรงพยาบาลเปาโล พระประแดง เป็นต้น
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านพระประแดง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									เนื่องจากมีกฎหมายผังเมืองห้ามก่อสร้างอาคารสูงในเส้นทางแนวรถไฟฟ้าสายสีม่วงใต้ช่วงสถานีเตาปูนลงไปทางทิศใต้บริเวณเมืองเก่า การพัฒนาอสังหาฯ จึงต้องเน้นไปที่อสังหาแนวราบเป็นหลัก ทำให้พระประแดงเป็นทำเลที่มีอสังหาฯ แนวราบอย่างบ้านเดี่ยว บ้านมือสองอยู่มาก ซึ่งถ้าเป็นบ้านติดถนนเส้นหลักหรือใกล้รถไฟฟ้าก็จะมีราคาสูงถึง 5-10 ล้านบาทก็มี แต่ถ้าขยับเข้าไปในซอยที่ไกลขึ้นก็จะมีราคาถูกลง อาจมีบ้านที่เรตเริ่มต้นเพียง 2 ล้านบาท ซึ่งเป็นราคาที่จับต้องได้สำหรับคนเริ่มทำงานที่ต้องการซื้อบ้านใกล้รถไฟฟ้าสายสีม่วงทางฝั่งพระประแดง
								</p>
								<p>
									ส่วนในด้านการลงทุนก็ถือว่าเป็นย่านที่ได้รับสนใจจากบริษัทพัฒนาอสังหาริมทรัพย์ชั้นนำมากเป็นอันดับต้นๆ ในการเข้ามาเปิดโครงการหมู่บ้าน ทำให้มีโอกาสในการลงทุนได้ผลตอบแทนที่ดี เนื่องจากยังพอหาที่อยู่อาศัยได้ในราคาที่ไม่สูงได้ ในราคาล้านต้นๆ เพื่อซื้อไว้เก็งกำไรหรืออยู่อาศัยเองได้ค่อนข้างมาก ตอบโจทย์ตลาดของคนที่ต้องการที่อยู่อาศัยและเริ่มต้องการขยับขยายครอบครัว รวมถึงต้องการที่อยู่อาศัยที่เดินทางสะดวก ใกล้สิ่งอำนวยความสะดวก ในราคาที่ยังเอื้อมถึงในทำเลที่ไม่ไกลจากตัวเมืองมากนัก
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'phra-samut-chedi'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้าน พระสมุทรเจดีย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									หลายคนที่กำลังมองหาบ้านในจังหวัดสมุทรปราการอาจมองว่า ทำเลพระสมุทรเจดีย์เป็นทำเลเก่าดั้งเดิม โดดเด่นในเรื่องของสถานที่ท่องเที่ยวเชิงอนุรักษ์ แต่จริงๆ แล้วการซื้อบ้านในทำเลพระสมุทรเจดีย์มีความคุ้มค่ามากกว่าที่ใครหลายคนคิด โดยเฉพาะเรื่องของการเจริญเติบโตของทำเลที่ปัจจุบันนับเป็นแหล่งซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ที่มีความต้องการซื้อสูง เนื่องจากเป็นทำเลที่มีสิ่งอำนวยความสะดวกครบครัน เดินทางง่าย และยังมีโอกาสเติบโตได้อีกมาก มาดูกันดีกว่าว่า จะมีปัจจัยอะไรบ้างที่ทำให้คนที่อยู่อาศัยในเมืองหลายคนเลือกซื้อบ้านในโซนพระสมุทรเจดีย์ซึ่งเป็นทำเลโซนชานเมืองเช่นนี้
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านพระสมุทรเจดีย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									มาเริ่มต้นกันที่เรื่องของการคมนาคมด้วยระบบขนส่งที่ทำให้หลายทำเลเจริญมากขึ้น นั่นคือ การมาถึงของรถไฟฟ้า โดยในทำเลนี้จะมีรถไฟฟ้าสายสีม่วงใต้ช่วงเตาปูน-ครุในพาดผ่าน โดยจะแบ่งออกเป็น 6 สถานีที่อยู่ในทำเลพระสมุทรเจดีย์และในโซนใกล้เคียง ได้แก่ สถานีดาวคะนอง, สถานีบางปะกอก, สถานีประชาอุทิศ สถานีราษฎร์บูรณะ, สถานีพระประแดง และสถานีครุใน ซึ่งเป็นโซนรถไฟฟ้าส่วนต่อขยายจากฝั่งจังหวัดนนทบุรี และยังสามารถนั่งไปเปลี่ยนสายเป็น MRT ได้ที่บริเวณสถานีบางซื่อได้อีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												ส่วนใครที่ต้องการใช้รถไฟฟ้า BTS สายสีเขียวก็สามารถขึ้นเรือข้ามฟากบริเวณองค์พระสมุทรเจดีย์ เพื่อไปใช้รถไฟฟ้า BTS ที่สถานีปากน้ำ และเดินทางเข้าเมืองไปยังอโศก พร้อมพงษ์ ทองหล่อ หรือจะใช้เดินทางออกนอกเมืองไปยังแถบจังหวัดสมุทรปราการโซนสำโรง-เคหะฯ ก็ได้เช่นกัน
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												สำหรับการเดินทางด้วยรถส่วนตัวก็เรียกได้ว่าแสนสะดวก เนื่องจากมีทางด่วนขั้นที่ 1 และขั้นที่ 2 สามารถใช้ทางด่วนไปลงดินแดง บางนา แจ้งวัฒนะ รามอินทรา พระราม 9 จตุจักร และบางใหญ่ได้ อีกทั้งยังอยู่ใกล้กับสะพานภูมิพล 1 และ 2 ใช้เส้นนี้เดินทางไปยัง พระราม 3 สีลม สาทร คลองเตย ปู่เจ้าสมิงพราย สุขุมวิท และบางนาได้อย่างสะดวก นอกจากนี้ยังมีทางพิเศษกาญจนาภิเษก (บางพลี-สุขสวัสดิ์) เริ่มต้นจากถนนสุขสวัสดิ์ บริเวณพระประแดงข้ามแม่น้ำเจ้าพระยาไปทางทิศตะวันออกผ่านถนนสุขุมวิท  ถนนศรีนครินทร์สามารถออกไปยาวจนถึงจังหวัดชลบุรีได้เลย
											</p>
											<p>
												หรือถ้าใครต้องการเดินทางไปยังพระราม 2 ศรีนครินทร์ เทพารักษ์ รามคำแหงก็สามารถใช้วงแหวนกาญจนาภิเษกในการเดินทางได้ ส่วนในอนาคตจะมีการทำถนนตัดใหม่ที่เป็นสะพานข้ามแม่น้ำเจ้าพระยา บริเวณพระสมุทรเจดีย์เชื่อม "สมุทรปราการ-สมุทรสาคร” เข้าไว้ด้วยกัน ทำให้การเดินทางข้ามจังหวัดในแถบปริมณฑลของกรุงเทพมหานครเป็นไปได้อย่างง่ายดายมากขึ้นด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้านสิ่งอำนวยความสะดวกภายในทำเลส่วนใหญ่จะเป็นไฮเปอร์มาร์เก็ต มีให้เลือกทั้ง Big C และ Tesco Lotus นอกจากนี้ก็มีตลาดสด สตรีทฟู้ด และ 7-11 หรือถ้าใครอยาก Shoppingแบบจริงๆ จังๆ ก็ต้องไปเส้นพระราม 2 จะมี Central Rama II และ The Mall ท่าพระ ซึ่งอยู่บนถนนรัชดาภิเษก เดินทางไปได้แบบไม่ไกลเลย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ในด้านสถานศึกษาก็มีให้ตัดสินใจเลือกอยู่หลายแห่ง เช่น โรงเรียนสารสาสน์ สมุทรสาร, โรงเรียนสารสาสน์วิเทศศึกษา, โรงเรียนสารสาสน์ประชาอุทิศพิทยาคาร ส่วนโรงพยาบาลก็จะมีโรงพยาบาลเปาโล เมโมเรียล พระประแดง, โรงพยาบาลบางปะกอก 3, โรงพยาบาลบางปะกอก 1, โรงพยาบาลบางปะกอก 9 อินเตอร์ฯ เป็นต้น
											</p>
											<p>
												ส่วนสถานที่ท่องเที่ยวเชิงอนุรักษ์และธรรมชาติใกล้เคียงก็จะมีบางกระเจ้า องค์พระสมุทรเจดีย์ ป้อมพระจุลจอมเกล้า พิพิธภัณฑ์พื้นบ้านขุนสมุทรจีน พิพิธภัณฑ์เรือหลวงแม่กลอง สถานตากอากาศบางปู ซึ่งเป็นสถานที่ท่องเที่ยวชื่อดังของจังหวัดสมุทรปราการ ซึ่งก็เหมาะสำหรับคนที่ต้องการใช้ชีวิตแบบ Work-Life Balance ที่อยากจะเดินทางไปทำงานสะดวก แต่ก็สามารถเดินทางออกสู่โซนธรรมชาติที่ช่วยทำให้ผ่อนคลายได้ง่ายด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านพระสมุทรเจดีย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้านการพัฒนาทำเลที่อยู่อาศัยในย่านพระสมุทรเจดีย์ยังคงมีอัตราการเติบโตอย่างต่อเนื่อง เพราะมีปัจจัยของรถไฟฟ้า การเดินทาง การทำถนนเพื่อเชื่อมต่อเส้นทางต่างๆ ทำให้การเดินทางจากโซนอื่นๆ ของกรุงเทพฯ มายังทำเลย่านสมุทรปราการไม่ได้ยากและใช้เวลานานเท่าเมื่อก่อน รวมถึงในแง่ของทำเลที่ตั้งที่ใกล้แหล่งงาน อีกทั้งสามารถเดินทางเข้า-ออกเมืองได้สะดวก ทั้งหมดนี้ล้วนมีส่วนช่วยส่งเสริมให้ตลาดที่อยู่อาศัยในย่านนี้ขยายตัว
								</p>
								<p>
									ส่วนลักษณะของที่อยู่อาศัยในย่านพระสมุทรเจดีย์ส่วนใหญ่จะเป็นโครงการหมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ เพื่อรองรับความต้องการของกลุ่มเป้าหมายที่อยากบ้านพักตากอากาศต่างจังหวัด, เปลี่ยนจากคอนโดฯเป็นบ้านแนวราบ และต้องการขยับทำเลเข้ามาใกล้เมืองมากขึ้น ซึ่งในปัจจุบันก็มีให้เลือกมากมายหลายโครงการ เช่น หมู่บ้านพฤกษาพระสมุทรเจดีย์, หมู่บ้านพฤกษา 77 พระสมุทรเจดีย์, หมู่บ้านภูมิใจนิเวศน์พระสมุทรเจดีย์, โครงการบ้านประชารัฐพระสมุทรเจดีย์ เป็นต้น
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'lasalle'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านลาซาล
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเลลาซาล-แบริ่ง นับเป็นทำเลที่เห็นความเปลี่ยนแปลงค่อนข้างมาก เพราะตั้งแต่การมาถึงของรถไฟฟ้าสายสีเขียว ช่วงอ่อนนุช-แบริ่ง ทำให้ทำเลนี้คึกคักเต็มไปด้วยที่อยู่อาศัยทั้งเก่าและใหม่ไม่ว่าจะเป็นโครงการบ้าน บ้านเดี่ยว บ้านแฝด หรือคอนโด เรียกได้ว่า มาเปิดตัวใหม่กันแบบอุ่นหนาฝาคั่ง รองรับการขยายตัวของเมืองได้เป็นอย่างดี ซึ่งถ้าใครกำลังเลือกซื้อบ้านในย่านลาซาลหรือละแวกใกล้เคียงในจังหวัดสมุทรปราการ ลองมาดูข้อดีหลายๆ  ข้อที่ทำให้ย่านลาซาลกลายเป็น Hub ที่อยู่อาศัยที่น่าสนใจสำหรับคนเมืองกันเลยดีกว่า
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านลาซาล
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									รถไฟฟ้าสายปัจจุบันที่นำพาให้ย่านลาซาลมีความคึกคักคือ รถไฟฟ้า BTS สายสีเขียวซึ่งเชื่อมต่อมาจากฝั่ง CBD อย่างสุขุมวิท เอกมัย มาจนถึงอ่อนนุช บางนา จนส่งผลให้ย่านลาซาล-แบริ่งที่อยู่ใกล้เคียงพลอยได้รับอานิสงส์จากการขยายของตัวเมือง ทำให้การเดินทางเข้า-ออกโซนชานเมืองของผู้คนตลอดแนวเส้นทางนี้ให้รวดเร็วยิ่งขึ้น พร้อมลดปัญหาการจราจรติดขัดในช่วงเวลาเร่งรีบได้เป็นอย่างดี
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												ส่วนในอนาคตก็จะมีรถไฟฟ้าสถานีศรีลาซาลตามแนวเส้นทางรถไฟฟ้าสายสีเหลืองบนถนนศรีนครินทร์ รวมทั้งมีแผนการพัฒนารถไฟฟ้าบางนา-สุวรรณภูมิ โดยมีแนวเส้นทางมีจุดเริ่มต้นบริเวณสี่แยกบางนา ซึ่งอยู่ใกล้กับย่านลาซาล อีกทั้งยังมีสกายวอร์กเชื่อมกับรถไฟฟ้าบีทีเอสฝั่งอาคารไบเทค ระยะทางประมาณ 550 เมตร ซึ่งถ้าใครต้องการจะเดินทางไปยังเส้นบางนา-ตราด สนามบินสุวรรณภูมิก็สามารถใช้รถไฟฟ้าสายอนาคตแห่งนี้ได้ โดยไม่จำเป็นต้องใช้รถยนต์ส่วนตัวเลย
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ส่วนใครที่มีรถส่วนตัวอยู่แล้ว การเดินทางในย่านลาซาลนั้นถือว่า สะดวกสบายเป็นอย่างมาก เนื่องจากเป็นทำเลที่เชื่อมต่อกับถนนได้หลากหลายเส้นทาง เช่น
											</p>
											<ul>
												<li>ถนนบางนา-ตราด : เชื่อมต่อกับทั้งถนนเส้นหลักอย่างถนนวงแหวนกาญจนาภิเษก และทางด่วนต่างๆ เช่น ทางพิเศษบูรพาวิถี ถนนมอเตอร์เวย์ ใช้ในการวิ่งเข้า-ออกเมืองได้อย่างสะดวก</li>
												<li>ถนนสุขุมวิท : สามารถใช้ถนนเส้นนี้ในการเดินทางเข้าเมืองไปยังเอกมัย ทองหล่อ พร้อมพงษ์ อโศกได้เลย</li>
												<li>ถนนศรีนครินทร์ : บริเวณต้นซอยลาซาลจะเชื่อมกับถนนสุขุมวิท ส่วนท้ายซอยจะเชื่อมต่อไปยังถนนศรีนครินทร์ ซึ่งสามารถเชื่อมต่อไปยังถนนบางนา-ตราด รวมไปถึงรามคำแหง และยังสามารถเชื่อมต่ออกไปยังชลบุรีได้อีกด้วย</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ความอุดมสมบูรณ์ของทำเลไม่ยิ่งหย่อนไปกว่าในเมืองเลย โดยสามารถชอปปิง เดินเล่น ใช้ชีวิต ได้ครบในหลายๆ โซนด้วยกันไม่ว่าจะเป็น…
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li><b>โซนถนนบางนา-ตราด :</b> สิ่งอำนวยความสะดวกจะมี Central บางนา เป็นห้างเก่าแก่ของพื้นที่ รอบห้างก็เต็มไปด้วยตลาด ร้านค้าร้านอาหาร และอาคารสำนักงานมากมาย ซึ่งสามารถเดินทางได้ง่ายๆโดยใช้ทางลัดจากซอยลาซาล 55 เพื่อออกมายังถนนบางนาก่อนถึงสะพานกลับรถเพื่อไปยังฝั่ง Centra ได้ง่ายๆ เลย หรือถ้าขับตรงไปก็จะเป็นแหล่งซื้อสินค้าใหม่ เช่น อิเกีย เมกาบางนา Index Living Mall ไทวัสดุ เป็นต้น</li>
												<li><b>โซนถนนสุขุมวิท :</b> ไล่มาตั้งแต่ฝั่งใจกลางเมืองอย่างอโศก ทองหล่อ เอกมัย อ่อนนุช บางนา มาจนถึงลาซาล เรียกได้ว่าจัดเต็มทั้งห้างสรรพสินค้าและ Community Mall และที่ใกล้ที่สุดเลยคือ ไบเทคบางนา ซึ่งจัดงานมหกรรมแสดงสินค้าอยู่บ่อยครั้ง</li>
												<li><b>โซนสำโรง :</b> โซนนี้จะมีห้างเก่าแก่อย่าง Imperial World และโดยรอบยังมีทั้งตลาดสด สินค้าราคาส่ง และโรงพยาบาลครบครัน สามารถไปชอปปิงซื้อของราคาย่อมเยาได้ในโซนนี้เลย</li>
												<li><b>โซนศรีนครินทร์ :</b>มีห้างซุปเปอร์มาร์เก็ตต่างๆ และคอมมูนิตี้มอล์เปิดใหม่อย่าง Jas Urban แมคโคร บิ๊กซี และฟิตเนสที่เปิดตลอด 24 ชั่วโมงอีกด้วย</li>
											</ul>
											<p>
												นอกจากนี้ลาซาลยังรายล้อมไปด้วยโรงเรียนต่างๆ เช่น โรงเรียนบางกอกพัฒนา, โรงเรียนนานาชาติเซนต์แอนดรูว์ส, โรงเรียนลาซาลกรุงเทพ, โรงเรียนเซนต์โยเซฟบางนา หรือโรงพยาบาล เช่น  โรงพยาบาลมนารมย์, โรงพยาบาลศิครินทร์, โรงพยาบาลไทยนครินทร์, โรงพยาบาลบางนา เป็นต้น เรียกได้ว่า สะดวกทั้งการใช้ชีวิตแบบคนโสด วัยทำงาน หรือแม้กระทั่งคนมีครอบครัว ต้องรับ-ส่งบุตรหลาน หรือมีผู้สูงอายุอยู่ภายในบ้านก็สามารถดูแลได้อย่างใกล้ชิดหากมีกรณีเจ็บป่วยเกิดขึ้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านลาซาล
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									จะเห็นได้ว่าพื้นที่โดยรอบสถานีรถไฟฟ้าบางนา และแบริ่งเป็นตัวผลักดันในซอยลาซาลหรือซอยสุขุมวิท 105 มีความเจริญเกิดขึ้นอย่างก้าวกระโดด และเป็นที่ตั้งของบ้านเดี่ยว บ้านแฝด ทาวน์เฮ้าส์ และคอนโดมากมาย เช่น ทาวน์เฮ้าส์ลาซาลนิเวศน์, NUE Noble ศรีนครินทร์ ลาซาล, ดิ ออริจิ้น สุขุมวิท 105, น็อตติ้ง ฮิลล์ สุขุมวิท 105 เป็นต้น
								</p>
								<p>
									ซึ่งผู้พัฒนารายต่าง ๆ เข้ามาจับจองพื้นที่ในทำเลแห่งนี้มากขึ้นเรื่อยๆ จนถึงขั้นพัฒนาโครงการอสังหาริมทรัพย์รูปแบบต่างๆ เพิ่มมากขึ้นในย่านลาซาลแห่งนี้ เช่น เมกาซิตี้ บางนา, แบงค็อก มอลล์, เซ็นทรัล วิลเลจ ซึ่งส่วนใหญ่เป็นอสังหาฯ ใหญ่แนว Mixed-Use ที่จะทำให้ย่านนี้มีผู้คนสัญจรและอยู่อาศัยเพิ่มขึ้นกว่าแต่ก่อนอย่างแน่นอน
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'samrong'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านสำโรง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									อสังหาริมทรัพย์ในย่านสำโรงนี้นับว่าเป็นที่น่าจับตามองเพราะขณะนี้สำโรงมีทั้งรถไฟฟ้า ห้างสรรพสินค้า ทางด่วนและยังมีพื้นที่สีเขียวด้วย เรียกว่าทั้งย่านสำโรงและสำโรงเหนือ เป็นชุมชนเก่าแก่ที่น่าอยู่มากแห่งหนึ่งด้วยอิทธิพลจากการขยายเมืองที่แผ่ขยายมาถึงย่านสำโรง สำโรงเหนือจึงทำให้ย่านนี้มีครบทุกอย่าง แต่ถึงจะเริ่มมองเห็นการพัฒนาบ้างแล้ว ราคาบ้านสำโรง ไม่ว่าจะเป็นบ้านเดี่ยว โครงการหมู่บ้าน บ้านมือสองต่างก็มีราคาไม่สูงมากนัก ยิ่งสำหรับนักลงทุนด้วยแล้วบ้านในย่านสำโรงยังถือเป็นย่านลงทุนที่น่าสนใจมากทีเดียว เพราะลงทุนแล้วยังได้กำไรมาก เนื่องจากราคาบ้านยังไม่สูงเท่าย่านใจกลางเมืองอื่นๆ
								</p>
								<p>
									รู้ถึงศักยภาพของทำเลขนาดนี้แล้ว มาดูกันดีกว่าว่าอะไรที่ทำให้การซื้อ-ขายบ้านสำโรงเป็นที่น่าสนใจ ที่ทำให้เหมาะทั้งกับการใช้ชีวิตและการลงทุนซื้อ-ขายบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม หรือคอนโดกันบ้าง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านสำโรง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									ย่านสำโรงมีสถานีรถไฟฟ้าส่วนต่อขยาย แบริ่ง-สมุทรปราการซึ่งเปิดให้บริการตั้งแต่ปี 2554 คอยเชื่อมต่อชุมชนบ้านสำโรงสู่สุขุมวิท สยาม และสีลมได้ง่ายมากขึ้น ทำให้คนเมืองหลายคนเลือกที่จะขยับออกมาอยู่นอกเมืองอีกนิดหนึ่ง เพราะด้วยราคาที่อยู่อาศัยที่ต่ำกว่าแต่ยังคงได้รับความสะดวกสบายเพราะด้วยอิทธิพลของการขยายเมืองที่แผ่ออกโดยรอบทำให้สำโรง สมุทรปราการได้รับการพัฒนาตามไปด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												ไม่เพียงแต่ย่านสำโรงเท่านั้น แต่ย่านใกล้เคียงอย่างศรีนครินทร์เองก็ได้รับการพัฒนาเมืองอย่างต่อเนื่องเช่นกัน ทำให้มีแผนการสร้างรถไฟฟ้าโมโนเรลสายสีเหลืองเพื่อเชื่อมต่อพื้นที่ด้านนอกอย่างลาดพร้าวจนถึงสำโรงซึ่งมีแผนคาดการณ์ว่าจะเปิดใช้ในปี 2565 ซึ่งรถไฟฟ้าโมโนเรลสายสีเหลืองนี้ยังสามารถเชื่อมต่อกับรถไฟฟ้าแอร์พอร์ตลิงก์ได้อีกด้วย
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ย่านสำโรงมีโครงการบ้านและที่พักอาศัยมากมายทำให้ในการเดินทางนับว่าสะดวกสะดวกสบายมากทีเดียว เพราะไม่เพียงมีรถไฟฟ้าที่เชื่อมเข้าเมืองได้ง่าย ยังมีเส้นทางสำหรับคนที่ใช้รถยนต์ในการเดินทางด้วยโดยย่านสำโรงสามารถเชื่อมต่อถนนและทางด่วนหลายเส้นทาง เช่น หากต้องการเข้าสามารถเชื่อมต่อกับถนนสุขุมวิทเพื่อเข้าสู่อโศกได้โดยตรง หรือหากต้องการออกจากเมืองก็สามารถใช้เส้นทางถนนบางนา-ตราด หรือขึ้นทางด่วนวิถีบูรพาหรือทางด่วนถนนกาญจนาภิเษกเพื่อไปยังถนนพระราม 2 ได้เช่นกัน
											</p>
											<p>
												ไม่เพียงแต่การเดินทางที่เชื่อมต่อทั้งในเมืองและนอกเมืองได้ง่ายแล้ว การเดินทางภายในย่านสำโรงเองก็นับว่าสะดวกและรวดเร็วเช่นกัน ยิ่งถ้าหากใครรู้จักเส้นทางแล้วสามารถลัดเลาะโดยใช้ถนนในตรอกซอยเพื่อเลี่ยงการจราจรที่ติดขัดในช่วงเวลาเร่งด่วนได้อีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ย่านสำโรงแหล่งไลฟ์สไตล์ครบครัน
								</h3>
								<p>
									ในทำเลสำโรงแห่งนี้ได้รองรับการพัฒนามาอย่างยาวนานทำให้มีแหล่งไลฟ์สไตล์อย่างห้างสรรพสินค้า อิมพิเรียลเวิล์ด สำโรง ซึ่งเป็นห้างขนาดใหญ่และตั้งอยู่มากว่า 30 ปี เรียกว่าเป็นผลมาจากช่วงแรกของการขยายตัวของเมืองเลยก็ว่าได้ นอกจากห้างสรรพสินค้าแล้ว สำโรงยังมีพิพิธภัณฑ์ช้างเอราวัณ ฟาร์มจระเข้และสวนสัตว์สมุทรปราการ เรียกว่าเหมาะสำหรับทุกคนในครอบครัวเลย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-2">
												ย่านสำโรง ชุมชนเก่าแสนอบอุ่น
											</h3>
											<p>
												เพราะแต่เดิมสำโรงก็เป็นแหล่งที่อยู่อาศัยที่มีทั้งบ้านเดี่ยว และโครงการบ้านจัดสรรมากมายอยู่นานแล้วทำให้ในย่านนี้มีตลาดขนาดใหญ่อย่างตลาดสำโรง ตลาดเอี่ยมเจริญให้จับจ่ายซื้อของสดของแห้งกันได้อย่างสะดวกสบาย ได้อารมณ์ของชุมชนดั้งเดิมอย่างเต็มที่ นอกจากตลาดที่เป็นแหล่งของกินแล้ว ยังมีสถานศึกษาอย่างโรงเรียนวัดด่านสำโรงหรือใกล้กันในซอยสุขุมวิท 113 ฝั่งแบริ่งก็ยังมีโรงเรียนนานาชาติเซนต์แอนดรูว์ส และโรงพยาบาลสำโรงการแพทย์อยู่ด้วย
											</p>
											<h3 class="mt-2">
												ย่านสำโรงแหล่งสำนักงานและโรงงานอุตสาหกรรม
											</h3>
											<p>
												อีกหนึ่งสิ่งที่ถือว่าเป็นเอกลักษณ์ของย่านสำโรงเลยก็คือ การเป็นแหล่งรองรับอาคารสำนักงานและโรงงานอุตสาหกรรมที่ยังสามารถขยายขึ้นได้อีก ซึ่งในปัจจุบันสำโรงมีแหล่งงานอุตสาหกรรมขนาดใหญ่และโรงงานขนาดใหญ่อย่าง นิคมอุตสาหกรรมบางปู ซึ่งภายในนิคมยังมีทั้งโรงงานผลิตชิ้นส่วนรถยนต์ โรงงานผลิตชิ้นส่วนอิเล็กทรอนิกส์อีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านสำโรง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									พื้นที่สำโรงยังคงสามารถรองรับการขยายตัวได้อีกมากทีเดียว เนื่องด้วยการเดินทางที่สะดวกสบาย สามารถการเชื่อมต่อไปยังแหล่ง CBD อื่นอย่างอโศก สีลมหรือพระราม 9 ทำให้มีโครงการ Mega Project อย่างโครงการ Bangkok mall และโครงการอื่นๆ ที่เตรียมจะพัฒนาพื้นที่เปลี่ยนย่านสำโรงให้น่าจับตามองมากขึ้น
								</p>
								<p>
									นอกจากโครงการ Mega Project ที่กำลังก่อสร้างกันอยู่แล้ว ยังมีแผนการเปิดรถไฟฟ้าโมโนเรลสายสีเหลือง ลาดพร้าว-สำโรงที่จะทำให้ย่านสำโรงแห่งนี้น่าจับตามองมากขึ้นหากใครที่คิดว่าต้องการลงทุน บ้านเดี่ยว บ้านมือสอง หรือโครงการคอนโดแล้วสำโรงแห่งนี้นับว่าเป็นตัวเลือกที่ดีเลยทีเดียว
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bang-bo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านย่านบางบ่อ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับคนที่สนใจโครงการบ้านบางบ่อ-บางพลีหรือทำเลใกล้นิคมอุตสาหกรรมที่มีความเป็นชุมชน ย่านนี้ถือว่าครบทุกการตอบโจทย์ของชีวิต ไม่ว่าจะเป็นเรื่องอาหารการกิน การเดินทาง ที่พักอาศัยอย่างโครงการหมู่บ้านที่มีราคาจับต้องได้ แต่ยังสามารถเชื่อมต่อได้ทุกไลฟ์สไตล์ที่ต้องการ เพราะเป็นทำเลที่อยู่ห่างจากเมืองไม่มากนัก
								</p>
								<p>
									มาดูกันดีกว่าว่าทำเลบางบ่อแห่งนี้มีความน่าสนใจอะไรบ้างที่สามารถตอบโจทย์การใช้ชีวิตและการลงทุนซื้อบ้านเดี่ยว บ้านแฝด ทาวน์เฮ้าส์หรือคอนโดในย่านนี้บ้าง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านบางบ่อ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mb-0">
									โครงการบ้านในย่านบางบ่อนับเป็นที่อยู่อาศัยที่เหมาะสำหรับคนที่ต้องการอยู่ในพื้นที่ชานเมืองแต่ต้องไม่ห่างจากเมืองมากนัก โดยเฉพาะกับคนที่ต้องเข้ากรุงเทพหรือออกต่างจังหวัดเช่นชลบุรี สมุทรปราการ พัทยา ก็สามารถทำได้โดยใช้เวลาไม่นาน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												จากบางบ่อเข้าโซนกรุงเทพฯ สามารถทำได้โดยทั้งแบบใช้ทางด่วน เพราะในย่านบางบ่อมีจุดขึ้น-ลงทางด่วนบูรพาวิถี สามารถใช้เพื่อเดินทางเข้าเมืองได้อย่างง่ายดาย แต่ถ้าหากไม่ต้องการขึ้นทางด่วนก็สามารถใช้ถนนเทพารักษ์เชื่อมไปยังถนนเมืองใหม่-บางพลีหรือถนนบางบ่อ-คลองด่านซึ่งจะเชื่อมไปยังถนนสุขุมวิทได้
											</p>
											<p class="mb-0">
												หากใครที่ไม่มีรถยนต์หรือต้องการเข้ากรุงเทพโดยไม่ใช้รถก็สามารถขึ้นรถตู้สายสำโรง-บางบ่อที่บริเวณโรงพยาบาลบางบ่อไปยังรถไฟฟ้า BTS สถานีแบริ่งก็ได้เช่นกัน
											</p>
											<p>
												นอกจากเข้ากรุงเทพแล้วเราสามารถใช้ทางด่วนบูรพาวิถีเพื่อไปยังชลบุรีได้ในเวลาเพียง 1 ชั่วโมงหรืออาจจะขับเลยไปเที่ยวพัทยาก็ไม่ใช่เรื่องยากอีกด้วย เหมาะสำหรับคนที่ต้องเดินทางไปทำงานระหว่างนิคมอุตสาหกรรมหรือครอบครัวที่ซื้อบ้านเดี่ยว โครงการหมู่บ้านในบางบ่อเพราะต้องการไปเที่ยวในวันหยุดโดยใช้เวลาเดินทางไม่นาน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p>
									ทำเลบางบ่อเป็นทำเลต่างจังหวัดที่มีความเจริญไม่ต่างจากเมืองใหญ่อื่นๆ เพราะเป็นเขตที่มีนิคมอุตสาหกรรมใหญ่อยู่ด้วยกันถึง 3 แห่งและยังมีมหาวิทยาลัย โรงเรียน โรงพยาบาลและตลาดอยู่ด้วยกันพร้อมสรรพ ทำให้การซื้อบ้านเดี่ยว บ้านมือสองหรือที่พักอาศัยในทำเลนี้สามารถตอบโจทย์ได้ครบทุกความต้องการในการใช้ชีวิตเลย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-2">
												ย่านบางบ่อแหล่งนิคมอุตสาหกรรมขนาดใหญ่
											</h3>
											<p>
												ในย่านบางบ่อนั้นสามารถเรียกได้ว่าแวดล้อมไปด้วยนิคมอุตสาหกรรมเลยทีเดียว เพราะทางตะวันตกของทำเลจะเป็นนิคมอุตสาหกรรมบางปูและนิคมอุตสาหกรรมบางพลี ทางตะวันออกเฉียงเหนือเป็นนิคมอุตสาหกรรมเวสโกรว์ ห่างออกไปอีกไม่ไกลยังมีนิคมอุตสาหกรรมในจังหวัดชลบุรีอย่างนิคมอุตสาหกรรมอมตะ ซิตี้ ชลบุรีหรือนิคมอุตสาหกรรมแหลมฉบังอยู่ด้วย จึงเหมาะสำหรับคนทำงานโรงงานอย่างวิศวกร เจ้าของโรงงานต่างๆ ที่อยากได้ที่พักอาศัยใกล้ทั้งแหล่งงานและใกล้ชิดคนในครอบครัวได้มากขึ้น
											</p>
											<h3 class="mt-2">
												ย่านบางบ่อชุมชนชานเมืองที่แสนครบครัน
											</h3>
											<p class="mb-0">
												นอกจากคนทำงานแล้วในย่านบางบ่อนี้ยังมีมหาวิทยาลัยอีกสองแห่งอยู่ด้วยนั่นคือ มหาวิทยาลัยหัวเฉียวเฉลิมพระเกียรติและมหาวิทยาลัยอัสสัมชัญตั้งอยู่ไม่ไกล นอกจากนี้ยังมีโรงเรียนเคหะบางพลี โรงเรียนบดิทนทร์เดชา สมุทรปราการ และโรงเรียนนวมินทราชินูทิศ สวนกุหลายวิทยาลัย สมุทรปราการอยู่ด้วยช่วยทำให้พื้นที่คึกคักมากขึ้น อีกทั้งในย่านนี้ยังมีตลาดใหญ่อย่างตลาดสดเสริมสุขและตลาดสดคลองด่าน ให้ได้ซื้อหาลิ้มลองกับปลาสลิดของดังของบางบ่อกันได้ด้วย
											</p>
											<p>
												ไม่เพียงมหาวิทยาลัยและตลาดเท่านั้นในบางบ่อ สมุทรปราการแห่งนี้ยังมีโรงพยาบาลอีกสามแห่งเปิดให้การดูแลคนในพื้นที่นั่นคือโรงพยาบาลบางนา 2 โรงพยาบาลบางบ่อและโรงพยาบาลรวมชัยประชารักษ์อยู่ด้วย ทำให้คนที่อาศัยอยู่ในโครงการหมู่บ้าน บ้านเดี่ยว หรือบ้านบางบ่อได้รับปัจจัยสี่ที่ครบครัน นับเป็นย่านที่ตอบโจทย์ได้ทุกจังหวะชีวิตเลยทีเดียว
											</p>
											<h3 class="mt-2">
												ย่านบางบ่อมีแหล่งท่องเที่ยวอีกมากมาย
											</h3>
											<p>
												กิจกรรมวันหยุดก็นับว่าเป็นสิ่งสำคัญ ซึ่งในย่านบางบ่อนี้นับว่ามีมากมายเลยทีเดียว ไม่ว่าจะเป็นวัดบางบ่อ วัดบางพลีน้อย วัดมงคลโคธาวาส หรือจะเป็นแหล่งออกกำลังกายอย่างสนามกอล์ฟสุภาพฤกษ์ Vintage Golf Club และเกียรติธานี คันทรี คลับด้วย สำหรับใครที่อยากเดินผ่อนคลายไปพร้อมกับหาซื้อของใช้เข้าบ้านในบางบ่อก็ยังมีโลตัส บางบ่อให้บริการอยู่ด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านบางบ่อ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเลบางบ่อเป็นทำเลของบ้านแนวราบที่มีราคาจับต้องได้คือ ตั้งแต่ 2-10 ล้านบาทขึ้นไป ยกตัวอย่างเช่น หมู่บ้านทรัพย์มั่นคง หมู่บ้านพฤกษา หมู่บ้านกิตตินคร หมู่บ้านบุราสิริ หรือหมู่บ้านชวนชื่น เป็นต้น ทำให้การพัฒนาพื้นที่ในย่านนี้เป็นไปเพื่อการอยู่อาศัยเป็นหลัก ไม่ว่าจะเป็นการสร้างโครงการหมู่บ้านซึ่งทำให้แหล่งไลฟ์สไตล์ต่างๆ มีขึ้นมามากขึ้น หรือเป็นแผนการสร้างโครงการรถไฟฟ้าสายสีเขียวส่วนต่อขยายจากเคหะสมุทรปราการ-บางปู เพื่อเชื่อมต่อนิคมอุตสาหกรรมบางปูและแหล่งท่องเที่ยวของจังหวัดสมุทรปราการเช่น เมืองโบราณ เป็นต้น ทำให้ในอนาคตทำเลบางบ่อแห่งนี้จะยังมีราคาที่ดินที่น่าจับตามองอย่างยิ่งทีเดียว
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'poo-chao-saming-prai'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านปู่เจ้าสมิงพราย
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเลปู่เจ้าสมิงพราย ถือเป็นอีกหนึ่งทำเลที่ผู้พัฒนาโครงการบ้านเดี่ยว คอนโด บ้านแฝด ทาวน์เฮ้าส์ เข้าไปจับจองพื้นที่เพื่อสร้างที่อยู่อาศัยค่อนข้างมาก เนื่องจากเป็นทำเลที่อยู่ติดกับย่านสำโรง ซึ่งเป็นพื้นที่ค้าขายเก่าแก่ และมีศักยภาพในการพัฒนาทำเลค่อนข้างสูงจากการตัดผ่านของรถไฟฟ้าถึง 2 สาย อีกทั้งยังเป็นทำเลที่สามารถเดินทางด้วยรถส่วนตัวง่าย สามารถเชื่อมต่อไปได้หลายเส้นทาง มาดูกันดีกว่าว่า สะดวกสบายสำหรับคนอยู่อาศัยอย่างไรบ้าง ถ้าหากต้องการซื้อบ้าน คอนโดในย่านปู่เจ้าสมิงพรายจะมีสิ่งอำนวยความสะดวกอะไรไหม ลองไปดูพร้อมๆ กันเลย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านปู่เจ้าสมิงพราย
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									เริ่มต้นกันในเรื่องการเดินทางด้วยรถไฟฟ้า ในปัจจุบันนี้มีรถไฟฟ้าสายสีเขียวส่วนต่อขยายตัดผ่านในย่านนี้ โดยสถานที่ใกล้ที่สุดคือ สถานีปู่เจ้าสมิงพราย เป็นสถานีที่อยู่ถัดจากสถานีสำโรงประมาณ 1.2 กิโลเมตร ซึ่งในอนาคตสถานีสำโรงนี้จะกลายเป็นสถานี Interchange ระหว่างรถไฟฟ้าสายสีเขียวเดิมกับรถไฟฟ้าสายสีเหลือง ช่วงลาดพร้าว-สำโรง แน่นอนว่า การมาของรถไฟฟ้าสายใหม่ก็จะยิ่งทำให้ทำเลบริเวณโดยรอบมีโอกาสพัฒนาขึ้นอีกมาก อีกทั้งรถไฟฟ้าสายสีเขียวยังมีแผนการก่อสร้างไปสิ้นสุดที่สถานีบางปู ก็จะยิ่งทำให้การเดินทางในจังหวัดสมุทรปราการเป็นไปได้ง่ายและรวดเร็วมากขึ้นด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												นอกจากนี้ยังมีโครงการก่อสร้างรถไฟฟ้าสายใหม่เพิ่มขึ้นอีก เช่น รถไฟฟ้าบางนา-สุวรรณภูมิ ซึ่งจะเชื่อมต่อกับรถไฟฟ้าบีทีเอสฝั่งอาคารไบเทค ระยะทางประมาณ 550 เมตร, รถไฮสปีดเทรน กรุงเทพฯ-ระยอง ที่จะเชื่อม 3 สนามบินดอนเมือง-สุวรรณภูมิ-อู่ตะเภาเข้าไว้ด้วยกัน ซึ่งจะช่วยทำให้การเข้าออกเมืองในโซนตะวันออกสะดวกมากขึ้นอีกหลายเท่าตัว
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												ด้านการเดินทางด้วยรถส่วนตัว เส้นทางของทำเลปู่เจ้าสมิงพรายถือได้ว่าสะดวกมาก เพราะเชื่อมต่อกับถนนเส้นสำคัญหลายสาย ได้แก่
											</p>
											<ul>
												<li>ถนนเทพารักษ์ ใช้เดินทางไปยังเส้นบางนา-ตราดเพื่อออกสู่ย่านศรีนครินทร์ หรือจะขึ้นทางด่วนบูรพาวิถีมุ่งหน้าไปสุขุมวิท สีลม สาทร เพื่อเข้าเมือง ส่วนขาออกออกนอกเมืองก็ใช้ทางด่วนเส้นนี้ไปยังชลบุรีได้ด้วยเช่นกัน</li>
												<li>ถนนปู่เจ้าสมิงพรายเชื่อมต่อพื้นที่บริเวณบางพลี – สุขสวัสดิ์ (พระราม 3) ได้</li>
												<li>สามารถใช้ถนนปู่เจ้าสมิงพรายผ่านถนนทางรถไฟสายเก่าและวงแหวนอุตสาหกรรม ไปสิ้นสุดที่ท่าเรือพระประแดงได้เลย</li>
												<li>มีทางพิเศษให้เลือกเดินทางได้หลากหลายเส้นทาง ได้แก่ ถนนกาญจนาภิเษก จุด-ขึ้นลงอยู่บริเวณช้างสามเศียร และทางพิเศษเฉลิมมหานคร จุดขึ้น-ลงอยู่บริเวณแยกบางนา</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับรอบๆ สถานี BTS และรอบๆ ทำเลปู่เจ้าสมิงพรายจะเป็นแหล่งอุตสาหกรรมขนาดใหญ่ ส่วนใหญ่จะเกี่ยวข้องกับยานยนต์เป็นหลัก เช่น ฮิตาชิ คอนซูมเมอร์ โปรดักส์ (ประเทศไทย), บริษัท โตโยต้า มอเตอร์, บจก. พานาโซนิค, A.P. Honda Co.,Ltd., Toyota Motor Thailand (Samrong Plant) เป็นต้น ทำเลนี้จึงเป็นส่วนผสมของการเป็นแหล่งทำงานปะปนกับแหล่งที่อยู่อาศัย โดยรอบๆ ก็จะมีโครงการบ้าน คอนโด ทาวน์เฮ้าส์บ้าง แต่จะไม่หนาแน่นเท่ากับย่านสำโรง แบริ่ง ลาซาล บางนา ทำให้การใช้ชีวิตเน้นไปที่การพักผ่อนหลังจากการทำงานมาอย่างเหน็ดเหนื่อยมากกว่า
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												ส่วนสถานที่จับจ่ายซื้อของ ส่วนใหญ่จะเป็นตลาด และร้านค้าแบบ Hypermarket เช่น บิ๊กซี สาขาสำโรง 2, Big C Jumbo, ตลาดสำโรง, ตลาดเอี่ยมเจริญ เป็นต้น ถ้าอยากจะเดินศูนย์การค้าขนาดใหญ่ก็สามารถไปชอป ชิม ชิลล์กันได้แถวถนนบางนา-ตราด เส้นนั้นจะเต็มไปด้วยห้างสรรพสินค้าขนาดใหญ่ เช่น อิเกียบางนา เซ็นทรัลบางนา เมกา บางนา ฯลฯ หรือถ้าต้องการท่องเที่ยวก็มีสถานที่สำคัญเชิงอนุรักษ์และเชิงธรรมชาติอยู่มากมาย เช่น บางกระเจ้า พิพิธภัณฑ์ช้างเอราวัณ สถานตากอากาศบางปู เป็นต้น
											</p>
											<p>
												หากใครกังวลเรื่องการเจ็บป่วย การรักษาพยาบาล ในทำเลปู่เจ้าสมิงพรายก็มีสถานพยาบาลให้เลือกใช้บริการหลายแห่ง เช่น โรงพยาบาลเมืองสมุทรปู่เจ้าสมิงพราย,  โรงพยาบาลสำโรงการแพทย์,  โรงพยาบาลไทยนครินทร์,  โรงพยาบาลศิครินทร์ เป็นต้น ในด้านสถานศึกษาเองก็ไม่น้อยหน้า มีทั้งโรงเรียนและมหาวิทยาลัยชั้นน้ำที่สามารถเดินทางส่งบุตรหลานไปศึกษาได้มากมาย เช่น วิทยาลัยเซาท์อีสต์บางกอก, โรงเรียนนานาชาติบางกอกพัฒนา, โรงเรียนเซนต์โยเซฟ บางนา, โรงเรียนลาซาล, วิทยาลัยเทคโนโลยีกรุงเทพ, ม.กรุงเทพ เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านปู่เจ้าสมิงพราย
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									จะเห็นว่า ปู่เจ้าสมิงพรายเป็นทำเลที่รองรับการขยายตัวของเมืองจากฝั่งสุขุมวิทตอนปลาย และเป็นแหล่งทำงานขนาดใหญ่จึงมีดีมานด์ในเรื่องของการอยู่อาศัยค่อนข้างมาก ส่งผลให้ทำเลนี้มีดีเวลลอปเปอร์หลายเจ้าเริ่มเข้าไปเปิดตัวโครงการบ้าน คอนโด ทาวน์เฮ้าส์มากขึ้นเรื่อยๆ เช่น Niche MONO Sukhumvit-Puchao, บ้านพฤกษา สำโรง-ปู่เจ้าฯ, Pause Sukhumvit 115, ศุภาลัย เวอเรนด้า สุขุมวิท 117, บี ลอฟท์ ไลท์ สุขุมวิท 115 เป็นต้น ส่วนด้านราคาของที่อยู่อาศัยในย่านนี้ยังถือว่าเป็นราคาที่ยังจับต้องได้ และมีให้เลือกหลายราคา
								</p>
								<p>
									โดยราคาขายบ้านเดี่ยวใกล้ BTS ปู่เจ้าสมิงพราย เริ่มต้นที่ 2-5 ล้านบาท ไปจนถึงราคา 10 ล้านบาท ราคาขายทาวน์เฮ้าส์ใกล้ BTS ปู่เจ้า เริ่มต้น 2-4 ล้านบาท และราคาของคอนโดมิเนียมในทำเลปู่เจ้าสมิงพรายจะมีตั้งแต่ราคาไม่ถึงล้านบาทไปจนถึงราคา 4-5 ล้านบาทเลยก็มี
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'bang-sao-thong'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านบางเสาธง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									อำเภอบางเสาธง เป็นทำเลของบ้านเดี่ยว บ้านหรู บ้านมือหนึ่งและมือสอง โดยได้รับอิทธิพลมาจากทำเลบางพลี-บางบ่อที่อยู่ใกล้เคียง ซึ่งทั้ง 3 ทำเลมีความคล้ายคลึงกันคือเป็นทำเลของแหล่งโรงงานอุตสาหกรรม โดยทำเลบางเสาธงจะมีโรงงานอยู่หลายโรงงานด้วยกัน เช่น นิคมอุตสาหกรรมเทพารักษ์, นิคมอุตสาหกรรมบางพลี, ไทยยามาฮ่ามอเตอร์ เป็นต้น
								</p>
								<p>
									เพราะเหตุนี้จึงทำให้ย่านนี้เป็นย่านที่มีพนักงานโรงงานจำนวนหลายหมื่นคนพักอาศัยอยู่ ซึ่งเป็นดีมานด์ที่ผู้พัฒนาโครงการต่างให้ความสนใจและเข้ามาเปิดตัวโครงการใหม่ๆ เป็นจำนวนมาก อีกทั้งยังได้รับอานิสงส์จากระบบการคมนาคมในทำเลที่ส่งผลให้จังหวัดสมุทรปราการมีศักยภาพในการกลายเป็น Hub ที่อยู่อาศัยได้มากขึ้นด้วย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านบางเสาธง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									สำหรับการคมนาคมในทำเลบางเสาธงในปัจจุบันมีรถไฟฟ้าสายสีเขียวส่วนต่อขยาย หรือที่เราเรียกกันว่า รถไฟฟ้า BTS ตัดผ่านในพื้นที่จังหวัดสมุทรปราการ โดยในปัจจุบันสิ้นสุดอยู่ที่สถานีเคหะสมุทรปราการ ส่วนในอนาคตมีแผนที่จะทำการต่อขยายไปจนถึงสถานีบางปู ซึ่งเป็นแหล่งท่องเที่ยวเชิงธรรมชาติและเป็นแหล่งที่อยู่อาศัยใหม่ของสมุทรปราการ และในอนาคตทำเลนี้ก็จะมีรถไฟฟ้าสายสีเหลืองซึ่งวิ่งจากย่านลาดพร้าว มาจนถึงสถานีสำโรง ซึ่งเป็นจุด Interchange ระหว่างรถไฟฟ้าสายสีเขียวอีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												แน่นอนว่า การเดินทางเข้า-ออกเมืองจากแถบชานเมืองของจังหวัดสมุทรปราการไปยังย่าน New CBD อย่างลาดพร้าว พระราม 9 และย่าน CBD อย่างอโศก พร้อมพงษ์ ทองหล่อ จะเป็นไปได้อย่างสะดวกและรวดเร็วมากขึ้นด้วย
											</p>
											<p>
												นอกจากนี้ยังมีโครงการก่อสร้างรถไฟฟ้าโมโนเรล สายบางปู–สุวรรณภูมิ ซึ่งเป็นโครงการรถไฟฟ้าที่เชื่อมต่อระบบรถไฟฟ้าบีทีเอสสายสุขุมวิทกับรถไฟฟ้าเชื่อมท่าอากาศยานสุวรรณภูมิเข้าด้วยกัน และจะมีรถไฮสปีดเทรน กรุงเทพฯ-ระยอง เชื่อมต่อสนามบินดอนเมือง สุวรรณภูมิและอู่ตะเภา ทำให้การคมนาคมในโซนตะวันออกของกรุงเทพฯ เชื่อมต่อถึงกันได้ดีขึ้นด้วย
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p>
												ด้านการเดินทางด้วยรถส่วนตัวย่านบางเสาธงสามารถเชื่อมต่อสู่ศูนย์กลางธุรกิจใจกลางเมืองได้ง่าย เนื่องจากอยู่ใกล้ทั้งทางด่วน ถนนวงแหวนรอบนอก และถนนมอเตอร์เวย์ โดยสามารถใช้ทางพิเศษบูรพาวิถี มุ่งหน้าสู่โซนสุขุมวิท-สาทร-สีลม ก็สะดวก หรือจะใช้มอเตอร์เวย์ เชื่อมสู่ทางด่วนพระราม 9 มุ่งหน้าเข้าโซน New CBD ก็ได้เช่นเดียวกัน นอกจากนี้ยังเชื่อมต่อสู่ถนนสายสำคัญเส้นอื่นๆ ได้หลากหลายไม่ว่าจะเป็นถนนกิ่งแก้ว, ถนนอ่อนนุช-ลาดกระบัง, ถนนบางพลี-ลาดกระบัง, ถนนบางนา-ตราด และถนนย่อยๆ ต่างๆ อีกมากมาย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									การจะอยู่อาศัยได้อย่างสบายใจ แน่นอนว่า ก็ต้องคำนึงถึงสิ่งอำนวยความสะดวกรอบๆ ทำเลด้วยว่าเหมาะกับรูปแบบการใช้ชีวิตหรือไม่ แน่นอนว่า ทำเลบางเสาธงสามารถตอบโจทย์การใช้ชีวิตของคนรุ่นใหม่ได้เป็นอย่างดี เพราะเป็นทำเลที่อยู่ใกล้สถานศึกษาและมหาวิทยาลัยชื่อดังอย่างมหาวิทยาลัยอัสสัมชัน, มหาวิทยาลัยหัวเฉียว ปลอดภัยจากโรคภัยไข้เจ็บ ด้วยการมีสถานพยาบาลคอยรองรับ เช่น โรงพยาบาลบางบ่อ, โรงพยาบาลบางนา 2, โรงพยาบาลรวมชัยประชารักษ์, โรงพยาบาลจุฬารัตน์ 5 ถ้าห่างออกไปหน่อยก็จะมีโรงพยาบาลเซ็นทรัลปาร์ค และโรงพยาบาลบางพลี
								</p>
								<p>
									นอกจากนี้ยังเป็นทำเลที่อยู่ใกล้สนามบินสุวรรณภูมิ และโรงงานอุตสาหกรรมมากมายจึงทำให้คึกคักและเต็มไปด้วยผู้คนทำให้แหล่งจับจ่ายซื้อของก็ต้องมีเยอะตามด้วย เช่น เทสโก้ โลตัส บางพลี, เทสโก้ โลตัส บางนา-ตราด, บิ๊กซี บางพลี, มาร์เก็ต วิลล่า ส่วนศูนย์การค้าขนาดใหญ่ และแหล่งขายวัสดุก่อสร้าง-ตกแต่งบ้าน ก็มีทั้งเมกา บางนา, อิเกีย บางนา, คิง เพาเวอร์ ศรีวารี คอมเพล็กซ์, โฮมโปร @ มาร์เก็ต วิลล่า, ไทยวัสดุ บางนา และบุญถาวร บางนา เรียกได้ว่า สามารถเดินทางเข้าถึงแหล่งชอป ชิม ชิลล์ ของจังหวัดสมุทรปราการได้ครบ จบในทำเลเดียว
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านบางเสาธง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									เนื่องจากเป็นทำเลที่ยังมีพื้นที่เหลืออยู่ ทำให้การพัฒนาโครงการที่อยู่อาศัยของย่านบางเสาธงจึงเป็นบ้านเดี่ยว บ้านจัดสรรที่มีพื้นที่ ซึ่งก็เหมาะสมกับตลาดผู้อยู่อาศัยในย่านนี้ที่ส่วนมากเป็นคนทำงาน หรือคนดั้งเดิมที่อยู่ในชุมชนบางเสาธงที่อาจจะมีครอบครัวและต้องการเป็นเจ้าของบ้านที่มีพื้นที่ให้ใช้สอยเยอะขึ้น แต่อยู่ในเรตราคาที่จับต้องได้
								</p>
								<p>
									เช่น บ้านพฤกษา บางเสาธง, หมู่บ้านออคิด บางเสาธง, ดีไลท์ อ่อนนุช – มอเตอร์เวย์, หมู่บ้านศุภวรรณ เวนิช สุวรรณภูมิ, Perfect Park Bangna เป็นต้น ซึ่งราคาก็มีทั้งระดับล้านต้นๆ ทั้งมือหนึ่งและมือสอง ทั้งนี้ก็ต้องขึ้นอยู่กับระยะการเดินทาง การเข้าซอย ขนาดของตัวบ้านและสไตล์การออกแบบจากตัวโครงการด้วย
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'pracha-uthit'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านมือสองประชาอุทิศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้วยความที่ชื่อถนนประชาอุทิศมีอยู่ด้วยกันในหลายพื้นที่ ไม่ว่าจะเป็นทางฝั่งห้วยขวาง, ประชาอุทิศในย่านดอนเมือง, ประชาอุทิศในจังหวัดนนทบุรี และประชาอุทิศทางฝั่งธนบุรี เกรงว่าจะทำให้หลายคนสับสนว่า เรากำลังจะพาไปดูทำเลไหนกันแน่?
								</p>
								<p>
									วันนี้ต้องบอกก่อนว่า เราจะพาไปดูทำเลบ้านมือสองประชาอุทิศที่คุ้นหูคุ้นตามากที่สุด นั่นก็คือ ประชาอุทิศในฝั่งธนบุรี มาดูกันดีกว่าว่า ประชาอุทิศในย่านนี้จะมีศักยภาพของทำเลเป็นอย่างไร และมีบ้านเดี่ยว บ้านหรู ทาวน์เฮ้าส์ บ้านแฝด คอนโด ในลักษณะใดบ้าง ตามไปดูพร้อมกันเลย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านประชาอุทิศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ระบบการคมนาคมด้วยรถไฟฟ้า
								</h3>
								<p class="mb-0">
									สิ่งที่ทำให้ทำเลบ้านมือสองประชาอุทิศนี้พัฒนาจนกลายเป็นแหล่งที่อยู่อาศัยของทั้งคนในย่านฝั่งธนบุรีไปจนถึงจังหวัดสมุทรปราการเลยก็คือ รถไฟฟ้าสายสีม่วงใต้ ช่วงเตาปูน-ราชฎร์บูรณะ รวมแล้วมีทั้งหมด 10 สถานี ซึ่งจะเดินรถเชื่อมต่อสายสีม่วงไปบางใหญ่ โดยที่ผู้โดยสารไม่ต้องลงจากขบวนรถ และจะช่วยเชื่อมการเดินทางและเปิดพื้นที่การพัฒนาของกรุงเทพฯโซนด้านใต้และตะวันตกให้เชื่อมต่อถึงกันง่ายมากขึ้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												นอกจากนี้ยังถือเป็นรถไฟฟ้าที่วิ่งผ่านย่านเก่า ผ่านชุมชนดั้งเดิมค่อนข้างมาก ทำให้รถไฟฟ้าสายนี้เป็นสิ่งที่ช่วยสนับสนุนให้บ้านมือสองประชาอุทิศเป็นแหล่งเศรษฐกิจและการท่องเที่ยวเชิงศิลปะและวัฒนธรรม เช่น หอศิลป์สมเด็จพระนางเจ้าสิริกิติ์ฯ ป้อมมหากาฬ วัดราชนัดดา วัดเทพธิดา และวัดสระเกตุ เป็นต้น
											</p>

											<h3>
												การเดินทางด้วยรถยนต์
											</h3>
											<p class="mb-0">
												บ้านมือสองประชาอุทิศ ด้านการเดินทางด้วยรถส่วนตัวถือได้ว่าค่อนข้างสะดวกเนื่องจากถนนประชาอุทิศเป็นถนนเส้นยาว มีระยะทางทั้งหมด 14 กิโลเมตร มีซอยเล็กซอยน้อยที่สามารถใช้ในการลัดเลาะไปยังจุดต่างๆ ได้ง่าย เช่น ซอยประชาอุทิศ 90 ซึ่งถือเป็นจุดศูนย์กลางของแหล่งที่อยู่อาศัยของย่านประชาอุทิศ เป็นซอยที่ใช้ในการลัดไปยังถนนบางขุนเทียน-ชายทะเล หรือจะขับรถออกไปโซนพระราม 2 โดยไม่ต้องย้อนไปทางถนนประชาอุทิศ เป็นทางเลือกในการเดินทาง ทำให้การอยู่อาศัยในย่านบ้านมือสองประชาอุทิศนี้ เหมือนอยู่ 3 จังหวัดเลยทีเดียว (สมุทรปราการ - กรุงเทพฯ - สมุทรสาคร)
											</p>
											<p>
												อีกทั้งบ้านมือสองประชาอุทิศ ยังเป็นทำเลที่เชื่อมต่อถนนเส้นสำคัญอีกหลายสาย ได้แก่ ถนนเส้นสำคัญในย่านนี้ ได้แก่ ถนนประชาอุทิศ สุขสวัสดิ์ พุทธบูชา ราษฎร์บูรณะ และพระราม 2 พร้อมเชื่อมต่อไปยังโซนสาทร พระราม 3 พระราม 4 และปู่เจ้าสมิงพรายได้อย่างสะดวก หรือถ้าใครต้องการเข้า-ออกเมืองเร็วขึ้น สามารถใช้ทางพิเศษอย่างทางพิเศษกาญจนาภิเษก และทางพิเศษเฉลิมมหานครได้ โดยทางพิเศษกาญจนาภิเษกจะใช้งานได้โดยเลี้ยวไปตามถนนพุทธบูชาจนเกือบจะถึงโรงพยาบาลบางปะกอก 3 จะเห็นจุดขึ้น-ลงทางพิเศษอยู่ ส่วนทางพิเศษเฉลิมมหานคร จะมีจุดขึ้น-ลงอยู่ใกล้ๆ กับแยกประชาอุทิศเลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกในการใช้ชีวิต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านมือสองประชาอุทิศ เป็นทำเลที่มีสิ่งอำนวยความสะดวกค่อนข้างครบ ทั้งไฮเปอร์มาร์เก็ต ซูเปอร์มาร์เก็ต สถานศึกษา โรงพยาบาล เช่น
								</p>
								<ul>
									<li>ห้างสรรพสินค้า จะมีบิ๊กซี บางปะกอก, เทสโก้โลตัสประชาอุทิศ, เซ็นทรัล พระราม 2</li>
									<li>โรงพยาบาล จะมีโรงพยาบาลสุขสวัสดิ์, โรงพยาบาลราชฎร์บูรณะ, โรงพยาบาลประชาพัฒน์, โรงพยาบาลบางปะกอก 1</li>
									<li>สถานศึกษา จะมีวิทยาลัยพณิชยการเชตุพน, มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี, โรงเรียนเมตตาวิทยา, โรงเรียนอนุบาลแสงอารีย์</li>
								</ul>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p>
												แต่ถึงแม้จะมีสิ่งอำนวยความสะดวกเพิ่มมากขึ้นเรื่อยๆ ทำเลบ้านมือสองประชาอุทิศ ก็ยังคงบรรยากาศของความเป็นโซนชานเมืองที่ไม่เร่งรีบเอาไว้ได้อยู่ในบางโซน เช่น โซนแนวคลองสรรพสามิต ที่ถนนค่อนข้างจะโล่งและไม่แออัดจนเกินไป บ้านมือสองประชาอุทิศจึงเหมาะจะเป็นทำเลของคนที่ต้องการหลีกหนีความวุ่นวายจากใจกลางเมือง ต้องการความสงบเมื่ออยู่บ้านในทำเลที่ยังคงมีศักยภาพในการพัฒนาเพิ่มขึ้นอีกเรื่อยๆ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านประชาอุทิศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ด้วยการคมนาคมที่สะดวกสบายของย่านประชาอุทิศ จากถนนที่สามารถเชื่อมต่อได้หลายเส้นทางและการเข้าถึงของรถไฟฟ้าสายสีม่วงใต้ ทำให้ดีมานด์ของการซื้อที่อยู่อาศัยบ้านมือสองประชาอุทิศ ไม่ว่าจะเป็นบ้านเดี่ยว บ้านแฝด บ้านหรู บ้าน 2 ชั้น อาคารพาณิชย์ หรือแม้กระทั่งคอนโด เพิ่มขึ้น แถมราคาของที่อยู่อาศัยในย่านนี้ยังถูกกว่าโซนพระราม 2 พระราม 3 และพระราม 4 ซึ่งเป็นพื้นที่ใกล้เคียง โดยบ้านเดี่ยวในย่านประชาอุทิศจะเริ่มอยู่ที่ประมาณ 5-6 ล้านบาท ทาวน์โฮมเริ่มต้นที่ 2.6-2.9 ล้านบาท ส่วนคอนโดจะเริ่มต้นที่ 1.5-2 ล้านบาท ซึ่งเป็นราคาเฉลี่ยที่คนส่วนใหญ่เอื้อมถึง
								</p>
								<p>
									ยกตัวอย่างโครงการบ้านมือสองประชาอุทิศที่น่าสนใจ เช่น โครงการบ้านพลีโน่ สุขสวัสดิ์-ประชาอุทิศ, โครงการบ้านสิริเพลส ประชาอุทิศ 90, โครงการบ้านเดี่ยว Centro ประชาอุทิศ 90, โครงการบ้าน villaggio ประชาอุทิศ, โครงการบ้านพฤกษ์ลดา ประชาอุทิศ 90, หมู่บ้านอินดี้ ประชาอุทิศ 90, หมู่บ้านเพฟ ประชาอุทิศ 90, โครงการบ้านเนเชอร่า ประชาอุทิศ 76-วงแหวนฯ, หมู่บ้านพฤกษา, ไอลีฟไพร์ม ประชาอุทิศ 90 เป็นต้น
								</p>
							</v-card>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'search'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'

export default {
	// scrollToTop: true,
	name: 'LIST',
	layout: 'default_2',

	components: {
		searchForm,
		propertyListItem,
		propertyListItemSkeleton
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let params = context.params
		let content = params.area || params.category || null
		let query = {}
		let widgetQuery = {}

		const market_selected = params.category === 'singlehome' ? 'HOME' : params.category === 'townhome' ? 'TOWNHOUSE' : params.category === 'condo' ? 'CONDO' : 'COMMERCIAL_BUILDING'

		// Category
		const year = new Date().getFullYear()
		const province = 2
		if (content === 'singlehome') {
			data['title'] = `รวมโครงการ บ้านเดี่ยวสมุทรปราการ บ้านมือสอง ราคา ขนาดพื้นที่ ${year}!`
			data['description'] = 'รวมทุกโครงการ บ้านเดี่ยวสมุทรปราการ ซื้อ ขาย พร้อมข้อมูลให้ครบ รูปภาพ ทำเล ราคา ขนาดพื้นที่ สิ่งอำนวยความสะดวก'
			data['script'] = [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify({
						'@context': 'https://schema.org',
						'@type': 'FAQPage',
						'mainEntity': [
							{
								'@type': 'Question',
								'name': 'ซื้อบ้านสมุทรปราการดีไหม',
								'acceptedAnswer': {
									'@type': 'Answer',
									'text': 'หากพูดถึงทำเล<a href="https://tb.co.th/singlehome">บ้านเดี่ยว</a> บ้านแฝด บ้านมือสองแถบชานเมืองที่น่าสนใจ หนึ่งในนั้นต้องนึกถึงทำเลอนาคตอย่างสมุทรปราการที่ตอนนี้มีรถไฟฟ้า BTS ส่วนต่อขยายเข้าถึงช่วงเคหะฯ แล้ว และย่านนี้ยังมีดีมานด์ด้านการอยู่อาศัยเติบโตอย่างต่อเนื่อง อย่างในโซนบางพลี บางปู ยังมีเรตราคาที่เอื้อมถึงเฉลี่ยที่ประมาณ 2-4 ล้านบาท'
								}
							},
							{
								'@type': 'Question',
								'name': 'ราคาบ้านสมุทรปราการ',
								'acceptedAnswer': {
									'@type': 'Answer',
									'text': 'ทำเลที่ตั้งของอสังหา ในจังหวัด สมุทรปราการ ที่ดินในแต่ละพื้นที่จะมีราคาไม่เท่ากัน โดยบริเวณที่อสังหามีราคาสูง จะเป็นบริเวณที่มีอาณาเขตติดกับกรุงเทพฯ เช่น บางนา ศรีนครินทร์ แบริ่ง จากนั้นราคาจะลดระดับลงมาตามระยะทางที่ห่างจากกรุงเทพ ซึ่งราคาจะมีการแบ่งแยกเป็น Tier ไว้ ดังนี้ ราคาต่ำกว่า 1, 2,  ล้าน'
								}
							}
						]
					})
				}
			]

			query = widgetQuery = {
				province,
				market_selected: 'HOME'
			}
		}
		else if (content === 'townhome') {
			data['title'] = `รวม ทาวน์โฮมสมุทรปราการ ทาวน์โฮมมือสอง ราคา ขนาดพื้นที่ ${year}!`
			data['description'] = `รวมข้อมูล ทาวน์โฮมสมุทรปราการ มือหนึ่ง มือสอง ไม่ใกล้จากกรุงเทพ ราคา 1 ล้าน ถึง 4 ล้าน ขนาดพื้นที่ 2 ชั้น 3 ชั้น ที่น่าสนใจ ในปี ${year}!`

			query = widgetQuery = {
				province,
				market_selected: 'TOWNHOUSE'
			}
		}
		else if (content === 'condo') {
			data['title'] = `รวม คอนโดสมุทรปราการ คอนโดมือสอง ราคา ขนาดพื้นที่ ${year}!`
			data['description'] = `รวมข้อมูล คอนโดสมุทรปราการ มือหนึ่ง มือสอง ราคา ขนาดพื้นที่ ทำเลยทอง ติดรถไฟฟ้า สิ่งอำนวยความสะดวกครบ ${year}!`

			query = widgetQuery = {
				province,
				market_selected: 'CONDO'
			}
		}
		else if (content === 'shophouse') {
			data['title'] = `รวม อาคารพาณิชย์สมุทรปราการ มือหนึ่ง มือสอง ราคา ขนาดพื้นที่ ${year}!`
			data['description'] = `รวม อาคารพาณิชย์สมุทรปราการ มือหนึ่ง มือสอง ราคา ขนาดพื้นที่ ในทำเลทอง ยอดนิยม มีสิ่งอำนวยความสะดวกครบ ปี ${year}!`

			query = widgetQuery = {
				province,
				market_selected: 'COMMERCIAL_BUILDING'
			}
		}

		// Area
		else if (content === 'srinakarin') {
			data['title'] = 'โครงการย่านศรีนครินทร์ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'รวมประกาศ ซื้อ-ขาย บ้าน คอนโด โครงการย่านศรีนครินทร์ บ้านเดี่ยว บ้านแฝด บ้านมือสอง ทาวน์โฮม พร้อมข้อมูลราคา ขนาดพื้นที่ ทำเล'

			query = widgetQuery = {
				market_selected,
				sub_district: [43,50,188,197,238,239,250,251]
			}
		}
		else if (content === 'thepharak') {
			data['title'] = 'โครงการบ้านย่านเทพารักษ์  สมุทรปราการ  บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่านเทพารักษ์ บ้านเดี่ยว บ้านมือสอง สมุทรปราการ ซื้อ-ขาย บ้าน พร้อมข้อมูล ราคา ทำเล ขนาดพื้นที่ ครบ จบที่นี่'

			query = {
				market_selected,
				sub_district: [238,251,260,263,269,270,271,298]
			}
		}
		else if (content === 'bang-phli') {
			data['title'] = 'โครงการบ้านย่าน บางพลี สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน บางพลี สมุทรปราการ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง บ้านเช่า รวมทุกโครงการ พร้อมข้อมูล ราคา ทำเล แผนที่ ขนาด ให้ครบ จบที่นี่'

			query = widgetQuery = {
				market_selected,
				district: [54]
			}
		}
		else if (content === 'bangna-trad') {
			data['title'] = 'โครงการบ้านย่านบางนา-ตราด สมุทรปราการ ซื้อ ขาย บ้าน โครงการต่างๆ'
			data['description'] = 'โครงการบ้านย่านบางนา-ตราด สมุทรปราการ ซื้อ ขาย บ้านเดี่ยว บ้านแฝด ทาวน์โฮม บ้านมือสอง โครงการหมู่บ้านต่างๆ พร้อมข้อมูล ราคา ทำเล'
			data['script'] = [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify({
						'@context': 'https://schema.org',
						'@type': 'FAQPage',
						'mainEntity': [
							{
								'@type': 'Question',
								'name': 'ซื้อบ้านบางนา-ตราดดีไหม',
								'acceptedAnswer': {
									'@type': 'Answer',
									'text': 'บ้านบางนา-ตราดเป็นหนึ่งในทำเลที่ควรจะซื้อเป็นอย่างมาก ถนนใหญ่บางนา-ตราดติดกับถนนสุขุมวิทโดยมีรถไฟฟ้าสายสีเขียว (สถานีบางนา) ส่วนฝั่งบางนา-ตราดจะรถไฟฟ้าสายสีเหลือง (สถานีศรีเอี่ยม) ที่ต่อไปยังสถานีสำโรงเส้นรถไฟฟ้าสายสุขุมวิทเส้นหลักได้อีกด้วย ทำให้โซนนี้มีมูลค่า บ้านเดี่ยว และบ้านประเภทอื่น ๆ อยู่ที่  2-5 ล้านบาท'
								}
							},
							{
								'@type': 'Question',
								'name': 'ราคาบ้านบางนา-ตราด',
								'acceptedAnswer': {
									'@type': 'Answer',
									'text': 'เนื่องจากโซนบ้านบางนา-ตราดจะอยู่ติดกับเส้นถนนสุขุมวิทมากที่สุด ทำให้ราคาอสังหาฯ สูงกว่าเขตพื้นที่อื่นๆ ส่วนเขตอื่นในโซนบาง-ตราด อาทิ บางพลี ศรีนครินทร์ กิ่งแก้ว บางบ่อ มูลค่าบ้านเดี่ยวจะตกราคาตาม Tier โดยวัดจากระยะห่างกรุงเทพฯ ประมาณ 1-2  ล้านบาท'
								}
							}
						]
					})
				}
			]

			query = widgetQuery = {
				market_selected,
				sub_district: [231,260,261,262,269,270,272,276,298,300,1454,1456,1457]
			}
		}
		else if (content === 'phraeksa') {
			data['title'] = 'โครงการบ้าน แพรกษา สมุทรปราการ หมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม'
			data['description'] = 'รวมประกาศขายบ้าน โครงการบ้าน แพรกษา สมุทรปราการ หมู่บ้าน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม พร้อมข้อมูล ทำเล พื้นที่ ราคา'

			query = widgetQuery = {
				market_selected,
				sub_district: [244,246,253]
			}
		}
		else if (content === 'bangpu') {
			data['title'] = 'โครงการบ้านย่านบางปู สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน บางปู, เมืองสมุทรปราการ หมู่บ้าน บ้านเดี่ยว บ้านมือสอง พร้อมรายละเอียดราคา สถานที่ใกล้เคียง ทำเล'

			query = widgetQuery = {
				market_selected,
				sub_district: [240,244,248]
			}
		}
		else if (content === 'phra-pradaeng') {
			data['title'] = 'โครงการบ้านย่านพระประแดง สมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน พระประแดง, สมุทรปราการ ซื้อ-ขาย เช่า โครงการบ้าน บ้านเดี่ยว บ้านมือสอง พร้อมข้อมูล ราคา ขนาดพื้นที่ ทำเล ครบจบที่นี่'

			query = widgetQuery = {
				market_selected,
				district: [55]
			}
		}
		else if (content === 'phra-samut-chedi') {
			data['title'] = 'โครงการบ้านย่านพระสมุทรเจดีย์ สมุทรปราการ ซื้อ-ขาย  บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'ซื้อ-ขาย โครงการบ้านย่านพระสมุทรเจดีย์, สมุทรปราการ บ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ พร้อมข้อมูล ราคา ทำเล ขนาดพื้นที่'

			query = widgetQuery = {
				market_selected,
				district: [56]
			}
		}
		else if (content === 'bearing') {
			data['title'] = 'โครงการบ้านย่านแบริ่ง ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'ซื้อ-ขายบ้านซอยแบริ่ง บ้านเดี่ยว บ้านมือสอง คอนโด พร้อมรายละเอียดข้อมูลครบ รูปภาพ ราคา ทำเล ขนาดพื้นที่ สิ่งอำนวยความสะดวก'

			query = widgetQuery = {
				market_selected,
				sub_district: [231,238]
			}
		}
		else if (content === 'lasalle') {
			data['title'] = 'โครงการบ้านย่าน ลาซาล สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน ลาซาล สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านแฝด ทาวน์โฮม พร้อมข้อมูลทำเล รายละเอียดราคา'

			query = widgetQuery = {
				market_selected,
				sub_district: [231,238]
			}
		}
		else if (content === 'samrong') {
			data['title'] = 'โครงการบ้านย่าน สำโรง สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน สำโรง สมุทรปราการ ซื้อ ขาย โครงการบ้าน บ้านเดี่ยว บ้านแฝด บ้านมือสอง ทาวน์โฮม คอนโด พร้อมข้อมูลทำเล รายละเอียดราคา'

			query = widgetQuery = {
				market_selected,
				sub_district: [238]
			}
		}
		else if (content === 'bang-bo') {
			data['title'] = 'โครงการบ้านย่าน บางบ่อ สมุทรปราการ ซื้อ ขาย โครงการหมู่บ้าน บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านแถวย่าน บางบ่อ สมุทรปราการ ซื้อ ขาย โครงการหมู่บ้านจัดสรร บ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด พร้อมข้อมูลราคา ทำเล'

			query = widgetQuery = {
				market_selected,
				district: [53]
			}
		}
		else if (content === 'poo-chao-saming-prai') {
			data['title'] = 'โครงการบ้านย่าน ปู่เจ้าสมิงพราย สมุทรปราการ ซื้อ ขาย โครงการ บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้าน แถวปู่เจ้าสมิงพราย สมุทรปราการ ซื้อ ขาย โครงการหมู่บ้าน คอนโด บ้านเดี่ยว บ้านแฝด บ้านเช่า บ้านมือสอง พร้อมข้อมูลราคา ทำเล'

			query = widgetQuery = {
				market_selected,
				sub_district: [282,284,292]
			}
		}
		else if (content === 'bang-sao-thong') {
			data['title'] = 'โครงการบ้านย่าน บางเสาธง สมุทรปราการ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านย่าน บางเสาธง สมุทรปราการ ซื้อ ขาย บ้านจัดสรร บ้านเดี่ยว บ้านใหม่ บ้านมือสอง บ้านเช่า พร้อมข้อมูลราคา ทำเล'

			query = widgetQuery = {
				market_selected,
				district: [57]
			}
		}
		else if (content === 'pracha-uthit') {
			data['title'] = 'โครงการบ้านมือสองประชาอุทิศ ทุ่งครุ ราษฎร์บูรณะ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้านแถวประชาอุทิศ ทุ่งครุ ราษฎร์บูรณะ สุขสวัสดิ์ ซื้อ ขาย โครงการหมู่บ้าน บ้านเดี่ยว บ้านแฝด บ้านมือสอง ทาวน์เฮ้าส์ ทาวน์โฮม พร้อมราคา'

			query = widgetQuery = {
				market_selected,
				sub_district: [293,294,296]
			}
		}

		widgetQuery = { ...query }

		await context.store.dispatch('page/initial', data)

		return {
			params, content, query, widgetQuery,
			areaSelected: params.area,
			location: 'สมุทรปราการ',
			locationName: 'samut-prakan',
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		empty: false,
		perPage: 12,
		propertyList: [],
		queryTxt: '',
		page: 1,
		total: 0,
	}),

	computed: {
		...mapGetters({
			getProperty: 'property/getProperty',
			head: 'page/head',
		}),

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},

		category () {
			if (this.content || this.content && ['singlehome','townhome','condo', 'shophouse'].includes(this.content)) {
				return [
					{ text: 'บ้านเดี่ยว', path: `/${this.locationName}/singlehome` },
					{ text: 'ทาวน์โฮม', path:  `/${this.locationName}/townhome` },
					{ text: 'คอนโด', path:  `/${this.locationName}/condo` },
					{ text: 'อาคารพาณิชย์', path:  `/${this.locationName}/shophouse` },
				]
			}

			return null
		},

		area () {
			if (this.content && [
				'singlehome', // 'townhome','condo', 'shophouse',
				'srinakarin','thepharak','bang-phli','bangna-trad','phraeksa','bangpu','phra-pradaeng','phra-samut-chedi','bearing',
				'lasalle','samrong','bang-bo','poo-chao-saming-prai','bang-sao-thong','pracha-uthit'
			].includes(this.content)) {
				return [
					{ text: 'ศรีนครินทร์', path: `/${this.locationName}/${this.params.category}/srinakarin`, value: 'srinakarin' },
					{ text: 'เทพารักษ์', path: `/${this.locationName}/${this.params.category}/thepharak`, value: 'thepharak' },
					{ text: 'บางพลี', path: `/${this.locationName}/${this.params.category}/bang-phli`, value: 'bang-phli' },
					{ text: 'บางนา-ตราด', path: `/${this.locationName}/${this.params.category}/bangna-trad`, value: 'bangna-trad' },
					{ text: 'แพรกษา', path: `/${this.locationName}/${this.params.category}/phraeksa`, value: 'phraeksa' },
					{ text: 'บางปู', path: `/${this.locationName}/${this.params.category}/bangpu`, value: 'bangpu' },
					{ text: 'พระประแดง', path: `/${this.locationName}/${this.params.category}/phra-pradaeng`, value: 'phra-pradaeng' },
					{ text: 'พระสมุทรเจดีย์', path: `/${this.locationName}/${this.params.category}/phra-samut-chedi`, value: 'phra-samut-chedi' },
					{ text: 'แบริ่ง', path: `/${this.locationName}/${this.params.category}/bearing`, value: 'bearing' },
					{ text: 'ลาซาล', path: `/${this.locationName}/${this.params.category}/lasalle`, value: 'lasalle' },
					{ text: 'สำโรง', path: `/${this.locationName}/${this.params.category}/samrong`, value: 'samrong' },
					{ text: 'บางบ่อ', path: `/${this.locationName}/${this.params.category}/bang-bo`, value: 'bang-bo' },
					{ text: 'ปู่เจ้าสมิงพราย', path: `/${this.locationName}/${this.params.category}/poo-chao-saming-prai`, value: 'poo-chao-saming-prai' },
					{ text: 'บางเสาธง', path: `/${this.locationName}/${this.params.category}/bang-sao-thong`, value: 'bang-sao-thong' },
					{ text: 'ประชาอุทิศ', path: `/${this.locationName}/${this.params.category}/pracha-uthit`, value: 'pracha-uthit' },
				]
			}

			return null
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},
	},

	watch: {
		page (newPage) {
			// this.$refs.top.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' })
			this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'end' })

			this.query.page = newPage
			this.search()
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			this.search()
		}
	},

	created() {
		if (process.client) {
			this.search()
		}
	},

	mounted() {

	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		search () {
			// if (this.loading) return
			this.loading = true
			this.propertyList = []
			this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = {
				...this.query,
				ipp: this.perPage // item per page
			}

			this.$nextTick(() => {
				// window.scrollTo(0, 0)
				this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'end' })
			})

			this.searchProperty(params).then(propObj => {
				this.propertyList = propObj.propsList
				this.total = propObj.total
				this.queryTxt = propObj.queryTxt
				this.perPage = propObj.perPage

				this.empty = this.propertyList.length === 0
				this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	padding: 32px 0 60px 0;

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgba(157,30,37,1);
	}

	.category-menu {
		position: relative;

		&::before {
			content: ' ';
			position: absolute;
			background: #fff;
			left: -24px;
			right: 0;
			top: -32px;
			bottom: -60px;
		}
		&::after {
			content: ' ';
			position: absolute;
			z-index: 0;
			width: 150vw;
			left: -84px;
			top: 0;
			bottom: 0;
			background: rgb(237,28,36);
		}

		& > div {
			position: relative;
			z-index: 1;
		}
	}
}
.area:hover, .area.v-btn--active {
	background-color: #3a3a3a;
	color: #fff;
}
.widget-btn .v-btn:hover {
	background-color: rgb(237,28,36);
	color: #fff;
	border-color: rgb(237,28,36);
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	p {
		text-indent: 30px;
	}

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
